// ========================================
// MULTI-GOAL FREE SHIPPING BAR
// ========================================

function initMultiGoalFreeShippingBar() {
  customElements.whenDefined('free-shipping-bar').then(function() {
    var FreeShippingBar = customElements.get('free-shipping-bar');
    if (!FreeShippingBar || FreeShippingBar.prototype._multiGoalPatched) return;

    var originalUpdateMessage = FreeShippingBar.prototype._updateMessage;
    FreeShippingBar.prototype._multiGoalPatched = true;

    function getLineItemProperties(item) {
      if (!item || !item.properties) return {};

      if (Array.isArray(item.properties)) {
        return item.properties.reduce(function(acc, prop) {
          acc[prop.name || prop.first || prop.key] = prop.value || prop.last;
          return acc;
        }, {});
      }

      return item.properties;
    }

    function getBundleShippingLinePrice(item) {
      var props = getLineItemProperties(item);
      var bundleRole = props._BundleRole || props['Bundle role'];

      if (bundleRole === 'child') {
        return 0;
      }

      if (bundleRole === 'parent' || props._BundleIsParent === 'true' || props._BundleComponents) {
        var discountedTotal = parseInt(props._BundleDiscountedTotal, 10);
        if (discountedTotal > 0) {
          return discountedTotal;
        }

        var bundlePricing = props._BundlePricing || props['Bundle pricing'];
        if (bundlePricing) {
          var parts = String(bundlePricing).split('|');
          var saleTotal = parseInt(parts[1], 10);
          if (saleTotal > 0) {
            return saleTotal;
          }
        }

        return item.final_line_price || 0;
      }

      if (item.requires_shipping) {
        return item.final_line_price || 0;
      }

      return 0;
    }

    function calculateShippingBarTotal(cart) {
      var priceForItems = (cart.items || []).reduce(function(sum, item) {
        return sum + getBundleShippingLinePrice(item);
      }, 0);
      var cartDiscount = (cart.cart_level_discount_applications || []).reduce(function(sum, discountAllocation) {
        return sum + discountAllocation.total_allocated_amount;
      }, 0);

      return priceForItems - cartDiscount;
    }

    FreeShippingBar.prototype._onCartChanged = function(event) {
      this.totalPrice = calculateShippingBarTotal(event.detail.cart);
    };

    function accentGratis(str) {
      return (str || '').replace(/GRATIS/gi, '<span class="bold text-accent k7-gratis-accent">$&</span>');
    }

    function getMultiGoalData(bar) {
      return [
        {
          amount: parseFloat(bar.getAttribute('data-goal-1-amount')),
          message: bar.getAttribute('data-goal-1-message')
        },
        {
          amount: parseFloat(bar.getAttribute('data-goal-2-amount')),
          message: bar.getAttribute('data-goal-2-message'),
          productTitle: bar.getAttribute('data-goal-2-product-title')
        },
        {
          amount: parseFloat(bar.getAttribute('data-goal-3-amount')),
          message: bar.getAttribute('data-goal-3-message'),
          productTitle: bar.getAttribute('data-goal-3-product-title')
        },
        {
          amount: parseFloat(bar.getAttribute('data-goal-4-amount')),
          message: bar.getAttribute('data-goal-4-message'),
          productTitle: bar.getAttribute('data-goal-4-product-title')
        }
      ].filter(function(g) { return g.amount > 0; });
    }

    function getRewardsConfig(bar) {
      var configScript = bar.querySelector('[data-k7-goal-rewards-config]');
      if (!configScript) return null;

      try {
        return JSON.parse(configScript.textContent);
      } catch (error) {
        console.error('Failed to parse goal rewards config:', error);
        return null;
      }
    }

    function formatMoney(formatter, cents) {
      return formatter.format((cents || 0) / 100).replace(/\$/g, '$$$$');
    }

    function getGoalIconHtml(bar, iconType) {
      var template = bar.querySelector('.k7-goal-reward-icon-templates [data-k7-goal-icon="' + iconType + '"]');
      return template ? template.innerHTML : '';
    }

    function buildRewardCard(goal, options) {
      var rewardsLpUrl = options.rewardsLpUrl || '';
      var extraClass = options && options.extraClass ? ' ' + options.extraClass : '';
      var compareMarkup = goal.comparePrice > 0
        ? '<span class="k7-goal-reward-card__price-compare line-through">' + formatMoney(options.formatter, goal.comparePrice) + '</span>'
        : '';

      var mediaMarkup = '';
      if (goal.type === 'shipping') {
        if (goal.image) {
          mediaMarkup = '<img src="' + goal.image + '" alt="' + goal.title.replace(/"/g, '&quot;') + '" class="k7-goal-reward-card__image" loading="lazy" width="200" height="150">';
        } else {
          mediaMarkup = '<div class="k7-goal-reward-card__icon-wrap">' + getGoalIconHtml(options.bar, 'truck') + '</div>';
        }
      } else if (goal.image) {
        mediaMarkup = '<img src="' + goal.image + '" alt="' + goal.title.replace(/"/g, '&quot;') + '" class="k7-goal-reward-card__image" loading="lazy" width="200" height="150">';
      } else {
        mediaMarkup = '<div class="k7-goal-reward-card__icon-wrap">' + getGoalIconHtml(options.bar, 'gift') + '</div>';
      }

      var thresholdMarkup = goal.thresholdLabel
        ? '<p class="k7-goal-reward-card__threshold text-xs">From ' + goal.thresholdLabel + ' order value</p>'
        : '';

      var innerMarkup =
        '<div class="k7-goal-reward-card__media">' + mediaMarkup + '</div>' +
        '<div class="k7-goal-reward-card__body">' +
          '<span class="k7-goal-reward-card__title text-sm">' + goal.title.replace(/</g, '&lt;') + '</span>' +
          thresholdMarkup +
          '<div class="k7-goal-reward-card__price text-xs">' +
            compareMarkup +
            '<span class="k7-goal-reward-card__gratis">GRATIS</span>' +
          '</div>' +
        '</div>';

      return '<div class="k7-goal-reward-card' + extraClass + '">' + innerMarkup + '</div>';
    }

    function updateGoalRewards(bar) {
      var rewardsContainer = bar.querySelector('.k7-free-shipping-bar__rewards');
      var config = getRewardsConfig(bar);
      if (!rewardsContainer || !config || !config.goals || !config.goals.length) return;

      var formatter = bar._currencyFormatter || new Intl.NumberFormat(Shopify.locale, { style: 'currency', currency: Shopify.currency.active });
      var totalPrice = bar.totalPrice;
      var rewardsLpUrl = config.rewardsLpUrl || bar.getAttribute('data-rewards-lp-url') || '';
      var wasOpen = rewardsContainer.querySelector('.k7-goal-rewards-accordion[open]') != null;
      var panelBg = config.panelBg || '';

      var cardsHtml = config.goals.map(function(goal) {
        var isCompleted = totalPrice >= goal.amount;
        return buildRewardCard(goal, {
          bar: bar,
          formatter: formatter,
          rewardsLpUrl: rewardsLpUrl,
          extraClass: isCompleted ? 'k7-goal-reward-card--completed' : ''
        });
      }).join('');

      if (panelBg) {
        rewardsContainer.style.setProperty('--k7-goal-rewards-panel-bg', panelBg);
      }

      rewardsContainer.innerHTML =
        '<details class="k7-goal-rewards-accordion accordion group"' + (wasOpen ? ' open' : '') + ' aria-expanded="' + (wasOpen ? 'true' : 'false') + '">' +
          '<summary>' +
            '<div class="accordion__toggle k7-goal-rewards-accordion__toggle">' +
              '<span class="k7-goal-rewards-accordion__label">Geschenke ansehen</span>' +
              '<span class="circle-chevron k7-goal-rewards-accordion__chevron group-hover:colors group-expanded:colors group-expanded:rotate">' +
                '<svg role="presentation" focusable="false" width="12" height="12" class="icon icon-chevron-bottom-small" viewBox="0 0 12 12">' +
                  '<path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"></path>' +
                '</svg>' +
              '</span>' +
            '</div>' +
          '</summary>' +
          '<div class="accordion__content">' +
            '<div class="k7-goal-rewards-list v-stack gap-2">' + cardsHtml + '</div>' +
          '</div>' +
        '</details>';
    }

    function enforceGoalMinSpacing(bar) {
      var track = bar.querySelector('.k7-free-shipping-bar__track');
      if (!track) return;

      var goals = Array.from(bar.querySelectorAll('.k7-free-shipping-bar__goal'));
      if (goals.length < 2) return;

      var trackWidth = track.offsetWidth;
      if (!trackWidth) return;

      var circleSize = 32;
      var minGapPx = circleSize + 4;
      var edgeInsetPx = circleSize / 2;
      var minGapPercent = (minGapPx / trackWidth) * 100;
      var minPos = (edgeInsetPx / trackWidth) * 100;
      var maxPos = 100 - minPos;

      var positions = goals.map(function(goal) {
        var raw = parseFloat(goal.getAttribute('data-goal-position'));
        return Number.isNaN(raw) ? minPos : raw;
      });

      for (var i = 1; i < positions.length; i++) {
        if (positions[i] - positions[i - 1] < minGapPercent) {
          positions[i] = positions[i - 1] + minGapPercent;
        }
      }

      if (positions[positions.length - 1] > maxPos) {
        positions[positions.length - 1] = maxPos;
        for (var j = positions.length - 2; j >= 0; j--) {
          if (positions[j + 1] - positions[j] < minGapPercent) {
            positions[j] = positions[j + 1] - minGapPercent;
          }
        }
      }

      if (positions[0] < minPos) {
        positions[0] = minPos;
        for (var k = 1; k < positions.length; k++) {
          if (positions[k] - positions[k - 1] < minGapPercent) {
            positions[k] = Math.min(maxPos, positions[k - 1] + minGapPercent);
          }
        }
      }

      goals.forEach(function(goal, index) {
        goal.style.left = positions[index] + '%';
      });
    }

    function refreshMultiGoalBar(bar) {
      if (bar._updateMessage) bar._updateMessage();
      enforceGoalMinSpacing(bar);
    }

    function refreshAllMultiGoalBars() {
      document.querySelectorAll('free-shipping-bar[data-multi-goal]').forEach(function(el) {
        refreshMultiGoalBar(el);
      });
    }
    FreeShippingBar.prototype._updateGoalRewards = function() {
      if (this.classList.contains('k7-free-shipping-bar--has-rewards')) {
        updateGoalRewards(this);
      }
    };

    FreeShippingBar.prototype._updateMessage = function() {
      var messageElement = this.querySelector('.k7-free-shipping-bar__content span');
      if (!messageElement) return;

      if (this.hasAttribute('data-multi-goal')) {
        var prefix = this.getAttribute('data-message-prefix') || 'Only';
        var goals = getMultiGoalData(this);
        var config = getRewardsConfig(this);
        var nextGoal = goals.find(function(g) { return this.totalPrice < g.amount; }.bind(this));
        var nextGoalProduct = null;

        if (nextGoal && config && config.goals) {
          nextGoalProduct = config.goals.find(function(g) {
            return g.amount === nextGoal.amount && g.type === 'product';
          });
        }

        if (!nextGoal) {
          messageElement.innerHTML = accentGratis(this.getAttribute('reached-message'));
        } else {
          var amountFormatted = this._currencyFormatter.format((nextGoal.amount - this.totalPrice) / 100).replace(/\$/g, '$$$$');
          var goal1Amount = parseFloat(this.getAttribute('data-goal-1-amount'));
          var goalLabel = nextGoal.amount === goal1Amount
            ? (nextGoal.message || '')
            : (nextGoalProduct && nextGoalProduct.title ? nextGoalProduct.title : (nextGoal.message || ''));
          messageElement.innerHTML = prefix + ' <span class="bold text-accent">' + amountFormatted + '</span> for ' + accentGratis(goalLabel);
        }

        this._updateGoalRewards();
      } else if (this.totalPrice >= this.threshold) {
        messageElement.innerHTML = this.getAttribute('reached-message');
      } else {
        var unreachedMessage = this.getAttribute('unreached-message') || '';
        if (/\{\{/.test(unreachedMessage)) {
          var formattedRemaining = this._currencyFormatter.format((this.threshold - this.totalPrice) / 100).replace(/\$/g, '$$$$');
          var amountMarkup = '<span class="bold text-accent">' + formattedRemaining + '</span>';
          messageElement.innerHTML = unreachedMessage
            .replace(/\{\{\s*amount\s*\}\}/gi, amountMarkup)
            .replace(/\{\{\s*remaining_amount\s*\}\}/gi, amountMarkup);
        } else {
          originalUpdateMessage.call(this);
        }
      }
    };

    var goalSpacingResizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(goalSpacingResizeTimer);
      goalSpacingResizeTimer = setTimeout(refreshAllMultiGoalBars, 100);
    });

    refreshAllMultiGoalBars();
    document.addEventListener('cart:change', function(event) {
      var delay = event.detail && event.detail.baseEvent === 'variant:add' ? 150 : 50;
      setTimeout(refreshAllMultiGoalBars, delay);
    });
    document.addEventListener('shopify:section:load', function() {
      setTimeout(refreshAllMultiGoalBars, 100);
    });
  });
}

initMultiGoalFreeShippingBar();

// ========================================
// LP JUBILAEUM GOAL BAR
// ========================================

function initLpJubilaeumGoalBar() {
  document.querySelectorAll('lp-jubilaeum-goal-bar').forEach(function(bar) {
    if (bar._lpJubCleanup) bar._lpJubCleanup();

    var sectionId = bar.dataset.sectionId;
    var progressBar = bar.querySelector('progress-bar');
    var goals = Array.from(bar.querySelectorAll('.lp-jub-goal-bar__goal'));
    var sectionRoot = document.getElementById('shopify-section-' + sectionId);
    var tierWraps = sectionRoot ? Array.from(sectionRoot.querySelectorAll('.lp-jub-tier-wrap')) : [];
    var scrollZone = sectionRoot ? sectionRoot.querySelector('.lp-jub-tiers-scroll') : null;
    var stickyEl = sectionRoot ? sectionRoot.querySelector('.lp-jub-tiers-scroll__sticky') : null;
    var mobileMedia = window.matchMedia('(max-width: 999px)');
    var goalPositions = goals.map(function(goal) {
      return parseFloat(goal.dataset.goalPosition);
    }).filter(function(value) {
      return !Number.isNaN(value);
    });
    var selectedIndex = 0;
    var isAutoScrolling = false;
    var scrollTicking = false;

    bar.dataset.initialized = 'true';

    function isMobileExperience() {
      return mobileMedia.matches && scrollZone && stickyEl;
    }

    function setProgress(percent) {
      if (!progressBar || Number.isNaN(percent)) return;
      var clamped = Math.max(0, Math.min(100, percent));
      progressBar.setAttribute('aria-valuemax', '100');
      progressBar.setAttribute('aria-valuenow', String(clamped));
      progressBar.style.setProperty('--progress', clamped / 100);
    }

    function interpolateGoalProgress(t, positions) {
      if (!positions.length) return 0;
      if (positions.length === 1) return positions[0];
      var scaled = t * (positions.length - 1);
      var segmentIndex = Math.min(positions.length - 2, Math.floor(scaled));
      var local = scaled - segmentIndex;
      return positions[segmentIndex] + (positions[segmentIndex + 1] - positions[segmentIndex]) * local;
    }

    function isDesktopExperience() {
      return !mobileMedia.matches;
    }

    function syncTierWrapInteractivity() {
      tierWraps.forEach(function(wrap, i) {
        if (isDesktopExperience()) {
          wrap.setAttribute('role', 'button');
          wrap.setAttribute('tabindex', '0');
          wrap.setAttribute('aria-pressed', i === selectedIndex ? 'true' : 'false');
        } else {
          wrap.removeAttribute('role');
          wrap.setAttribute('tabindex', '-1');
          wrap.removeAttribute('aria-pressed');
        }
      });
    }

    function setSelection(index) {
      if (index < 0 || index >= goals.length) return;
      selectedIndex = index;
      goals.forEach(function(goal, i) {
        var isSelected = i === index;
        goal.classList.toggle('is-selected', isSelected);
        goal.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
      tierWraps.forEach(function(wrap, i) {
        wrap.classList.toggle('lp-jub-tier-wrap--selected', i === index);
      });
      syncTierWrapInteractivity();
    }

    function selectTier(index) {
      if (index < 0 || index >= goals.length) return;
      setSelection(index);
      var goalPosition = goalPositions[index];
      if (!Number.isNaN(goalPosition)) setProgress(goalPosition);
    }

    function updateStickyMetrics() {
      if (!scrollZone || !stickyEl || !isMobileExperience()) return;
      scrollZone.style.setProperty('--lp-jub-sticky-height', stickyEl.offsetHeight + 'px');
    }

    function updateStickyState() {
      if (!scrollZone || !stickyEl || !isMobileExperience()) {
        if (stickyEl) stickyEl.classList.remove('is-stuck');
        return;
      }
      var zoneRect = scrollZone.getBoundingClientRect();
      var stickyTop = stickyEl.getBoundingClientRect().top;
      var isStuck = zoneRect.top <= stickyTop + 1 && zoneRect.bottom > stickyTop + stickyEl.offsetHeight + 8;
      stickyEl.classList.toggle('is-stuck', isStuck);
    }

    function getScrollProgress() {
      if (!scrollZone) return 0;
      var zoneTop = scrollZone.getBoundingClientRect().top + window.scrollY;
      var maxScroll = Math.max(1, scrollZone.offsetHeight - window.innerHeight);
      return Math.max(0, Math.min(1, (window.scrollY - zoneTop) / maxScroll));
    }

    function updateFromScroll() {
      if (!isMobileExperience()) return;

      updateStickyState();
      var t = getScrollProgress();
      setProgress(interpolateGoalProgress(t, goalPositions));

      var activeIndex = goals.length > 1 ? Math.round(t * (goals.length - 1)) : 0;
      setSelection(activeIndex);
    }

    function scrollToTier(index) {
      if (!scrollZone || index < 0 || index >= goals.length) return;

      var zoneTop = scrollZone.getBoundingClientRect().top + window.scrollY;
      var maxScroll = Math.max(1, scrollZone.offsetHeight - window.innerHeight);
      var t = goals.length > 1 ? index / (goals.length - 1) : 0;
      var targetScroll = zoneTop + t * maxScroll;
      var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

      isAutoScrolling = true;
      selectTier(index);

      window.scrollTo({ top: targetScroll, behavior: behavior });

      window.setTimeout(function() {
        isAutoScrolling = false;
        updateFromScroll();
      }, behavior === 'smooth' ? 900 : 50);
    }

    function onScroll() {
      if (!isMobileExperience() || isAutoScrolling) return;
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(function() {
        updateFromScroll();
        scrollTicking = false;
      });
    }

    function onMediaChange() {
      updateStickyMetrics();
      syncTierWrapInteractivity();
      if (isMobileExperience()) {
        updateFromScroll();
      } else {
        if (stickyEl) stickyEl.classList.remove('is-stuck');
        selectTier(selectedIndex);
      }
    }

    goals.forEach(function(goal, index) {
      goal.addEventListener('click', function() {
        if (isMobileExperience()) {
          scrollToTier(index);
        } else {
          selectTier(index);
        }
      });
    });

    tierWraps.forEach(function(wrap, index) {
      wrap.addEventListener('click', function() {
        if (!isDesktopExperience()) return;
        selectTier(index);
      });
      wrap.addEventListener('keydown', function(event) {
        if (!isDesktopExperience()) return;
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        selectTier(index);
      });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updateStickyMetrics, { passive: true });
    mobileMedia.addEventListener('change', onMediaChange);

    bar._lpJubCleanup = function() {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', updateStickyMetrics);
      mobileMedia.removeEventListener('change', onMediaChange);
      delete bar.dataset.initialized;
    };

    updateStickyMetrics();
    selectTier(0);
    if (isMobileExperience()) updateFromScroll();
  });
}

document.addEventListener('DOMContentLoaded', initLpJubilaeumGoalBar);
document.addEventListener('shopify:section:load', function() {
  setTimeout(initLpJubilaeumGoalBar, 100);
});

// ========================================
// DESCRIPTION READ MORE/LESS FUNCTIONALITY
// ========================================

document.addEventListener('DOMContentLoaded', function() {
  initReadMoreButtons();
  setTimeout(function() {
    initQuantityPresets();
    initDiscountBadgeCycling();
  }, 100);
  initPresetsPopup();
  initVariantAddedCartButton();
  
  document.addEventListener('shopify:section:load', function() {
    initReadMoreButtons();
    setTimeout(function() {
      document.querySelectorAll('.bk-media-quantity-presets__discount-badges').forEach(container => {
        if (container.dataset.cyclingIntervalId) {
          clearInterval(parseInt(container.dataset.cyclingIntervalId));
          delete container.dataset.cyclingIntervalId;
        }
        delete container.dataset.cyclingInitialized;
        
        const badges = container.querySelectorAll('.bk-media-quantity-presets__discount-badge');
        badges.forEach(badge => {
          const percentText = badge.querySelector('.bk-media-quantity-presets__discount-badge-percent');
          const quantityText = badge.querySelector('.bk-media-quantity-presets__discount-badge-quantity');
          if (percentText) percentText.classList.remove('is-hidden');
          if (quantityText) quantityText.classList.add('is-hidden');
        });
      });
      document.querySelectorAll('.quantity-selector__input').forEach(input => {
        delete input.dataset.badgeStylesInitialized;
      });
      initQuantityPresets();
      initDiscountBadgeCycling();
    }, 100);
    initPresetsPopup();
    initVariantAddedCartButton();
  });
  
  document.addEventListener('product:rerender', function() {
    requestAnimationFrame(function() {
      document.querySelectorAll('.bk-media-quantity-presets__discount-badges').forEach(container => {
        if (container.dataset.cyclingIntervalId) {
          clearInterval(parseInt(container.dataset.cyclingIntervalId));
          delete container.dataset.cyclingIntervalId;
        }
        delete container.dataset.cyclingInitialized;
      });
      document.querySelectorAll('.quantity-selector__input').forEach(input => {
        delete input.dataset.badgeStylesInitialized;
      });
      initQuantityPresets();
      initDiscountBadgeCycling();
    });
  });
});

function updateAccordionDisplay(quantityInput) {
  const formControl = quantityInput.closest('.product-info__quantity-selector');
  if (!formControl) return;
  
  const accordionContainer = formControl.querySelector('.bk-media-quantity-presets--accordion');
  if (!accordionContainer) return;
  
  const presetDisplay = accordionContainer.querySelector('.bk-media-quantity-preset-display');
  if (!presetDisplay) return;
  
  const quantity = parseInt(quantityInput.value) || 1;
  const presetDataItems = Array.from(presetDisplay.querySelectorAll('.bk-media-quantity-preset-data'));
  
  let matchingPresetData = null;
  let highestMatchingQuantity = 0;
  
  presetDataItems.forEach(item => {
    const itemQuantity = parseInt(item.getAttribute('data-quantity'));
    if (itemQuantity && itemQuantity <= quantity && itemQuantity > highestMatchingQuantity) {
      highestMatchingQuantity = itemQuantity;
      matchingPresetData = item;
    }
  });
  
  const selectedImageContainer = presetDisplay.querySelector('.bk-media-quantity-accordion__selected-image');
  const selectedImage = presetDisplay.querySelector('.bk-media-quantity-accordion__selected-img');
  const selectedLabel = presetDisplay.querySelector('.bk-media-quantity-accordion__selected-label');
  
  const imageUrl = matchingPresetData ? matchingPresetData.getAttribute('data-image-url') : null;
  
  let form = null;
  const quantityInputFormId = quantityInput.getAttribute('form');
  if (quantityInputFormId) {
    form = document.getElementById(quantityInputFormId);
  }
  if (!form) {
    form = quantityInput.closest('form[id^="product-form"]');
  }
  if (!form) {
    form = document.querySelector('form[is="product-form"]');
  }
  
  let variantData = null;
  if (form) {
    const variantIdInput = form.querySelector('input[name="id"]');
    if (variantIdInput && variantIdInput.value) {
      variantData = getVariantData(variantIdInput.value);
    }
  }
  
  if (selectedImageContainer && selectedImage) {
    if (imageUrl) {
      selectedImage.src = imageUrl;
      selectedImage.style.display = 'block';
      selectedImageContainer.style.display = 'flex';
    } else {
      selectedImage.style.display = 'none';
      selectedImageContainer.style.display = 'none';
    }
  } else if (selectedImageContainer) {
    selectedImageContainer.style.display = 'none';
  }
  
  const quantityLabelPrefix = getQuantityLabelPrefix();
  if (selectedLabel && selectedLabel.textContent !== quantityLabelPrefix) {
    selectedLabel.textContent = quantityLabelPrefix;
  }
}

function initReadMoreButtons() {
  const readMoreContainers = document.querySelectorAll('.bk-media-description-read-more');
  
  readMoreContainers.forEach(container => {
    const button = container.querySelector('.bk-media-read-more-button');
    const readMoreText = container.querySelector('.bk-media-read-more-text');
    const readLessText = container.querySelector('.bk-media-read-less-text');
    
    if (!button || button.dataset.initialized) return;
    
    button.dataset.initialized = 'true';
    
    button.addEventListener('click', function() {
      const isExpanded = container.classList.contains('is-expanded');
      
      if (isExpanded) {
        container.classList.remove('is-expanded');
        button.setAttribute('aria-expanded', 'false');
        readMoreText.style.display = '';
        readLessText.style.display = 'none';
      } else {
        container.classList.add('is-expanded');
        button.setAttribute('aria-expanded', 'true');
        readMoreText.style.display = 'none';
        readLessText.style.display = '';
      }
    });
  });
}

// ========================================
// QUANTITY PRESETS FUNCTIONALITY
// ========================================

function formatMoney(cents) {
  if (!window.themeVariables) return '';
  const format = window.themeVariables.settings.currencyCodeEnabled 
    ? window.themeVariables.settings.moneyWithCurrencyFormat 
    : window.themeVariables.settings.moneyFormat;
  
  const amount = (cents / 100).toFixed(2);
  const amountNoDecimals = Math.round(cents / 100);
  
  let formatted = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  let formattedNoDecimals = amountNoDecimals.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
  return format
    .replace(/\{\{amount_with_comma_separator\}\}/g, formatted)
    .replace(/\{\{amount_no_decimals_with_comma_separator\}\}/g, formattedNoDecimals)
    .replace(/\{\{amount\}\}/g, amount)
    .replace(/\{\{amount_no_decimals\}\}/g, amountNoDecimals);
}

function setPriceElementContent(element, moneyText) {
  if (!element) return;

  const srOnly = element.querySelector('.sr-only');
  element.textContent = '';

  if (srOnly) {
    element.appendChild(srOnly);
  }

  element.appendChild(document.createTextNode(moneyText));
}

function getPriceBlockPriceListElements(priceBlockContainer) {
  if (!priceBlockContainer) return {};

  const priceList = priceBlockContainer.querySelector('price-list');

  return {
    salePrice: priceList?.querySelector('sale-price') || null,
    compareAtPrice: priceList?.querySelector('compare-at-price') || null,
    unitPrice: priceList?.querySelector('unit-price') || null,
    discountBadge: priceBlockContainer.querySelector('.bk-media-quantity-price-discount-badge') || null,
    priceListContainer: priceBlockContainer.querySelector('.bk-media-quantity-price-container') || null
  };
}

function updateVariantCompareAtPrice(salePrice, compareAtPrice, basePriceCents, compareAtCents) {
  if (!salePrice) return;

  if (compareAtPrice && compareAtCents > basePriceCents) {
    setPriceElementContent(compareAtPrice, formatMoney(compareAtCents));
    compareAtPrice.style.display = '';
    salePrice.classList.add('text-on-sale');
    salePrice.classList.remove('text-subdued');
  } else if (compareAtPrice) {
    compareAtPrice.style.display = 'none';
    salePrice.classList.remove('text-on-sale');
    salePrice.classList.add('text-subdued');
  }
}

function ensureCompareAtPriceElement(priceList, salePrice) {
  if (!priceList) return null;

  let compareAtPrice = priceList.querySelector('compare-at-price');

  if (!compareAtPrice) {
    compareAtPrice = document.createElement('compare-at-price');
    compareAtPrice.className = 'text-subdued line-through';

    if (salePrice) {
      salePrice.insertAdjacentElement('afterend', compareAtPrice);
    } else {
      priceList.appendChild(compareAtPrice);
    }
  }

  return compareAtPrice;
}

function updateQuantityPrice(quantityInput, basePriceCentsOverride) {
  const formControl = quantityInput.closest('.product-info__quantity-selector');
  if (!formControl) return;
  
  const quantity = parseInt(quantityInput.value) || 1;
  
  const priceContainer = formControl.querySelector('.bk-media-quantity-price');
  const originalPriceContainer = formControl.querySelector('.bk-media-quantity-price-original');
  
  const priceBlockContainer = document.querySelector('.bk-media-price-preset-container');
  const {
    salePrice: priceBlockSalePrice,
    compareAtPrice: priceBlockCompareAtPrice,
    unitPrice: unitPriceElement,
    discountBadge: priceBlockDiscountBadge,
    priceListContainer: priceBlockPriceContainer
  } = getPriceBlockPriceListElements(priceBlockContainer);
  let priceBlockDiscountedUnitPrice = priceBlockContainer?.querySelector('.bk-media-quantity-price-discounted-unit');
  if (!priceBlockDiscountedUnitPrice && priceBlockContainer && priceBlockPriceContainer) {
    priceBlockDiscountedUnitPrice = document.createElement('span');
    priceBlockDiscountedUnitPrice.className = 'bk-media-quantity-price-discounted-unit text-sm text-subdued';
    if (priceBlockDiscountBadge) {
      priceBlockDiscountBadge.insertAdjacentElement('afterend', priceBlockDiscountedUnitPrice);
    } else if (priceBlockSalePrice) {
      priceBlockSalePrice.insertAdjacentElement('afterend', priceBlockDiscountedUnitPrice);
    } else {
      priceBlockPriceContainer.appendChild(priceBlockDiscountedUnitPrice);
    }
  }
  
  const basePriceCents = basePriceCentsOverride !== undefined 
    ? basePriceCentsOverride 
    : (parseInt(priceContainer?.getAttribute('data-price') || priceBlockContainer?.getAttribute('data-variant-price') || '0') || 0);
  const compareAtCents = parseInt(priceBlockContainer?.getAttribute('data-variant-compare-at') || '0') || 0;
  const totalCents = basePriceCents * quantity;
  
  const quantitySelectorBlock = document.querySelector('.product-info__quantity-selector');
  
  let discount = 0;
  let highestMatchingQuantity = 0;
  
  const presetButton = quantitySelectorBlock?.querySelector(`.bk-media-quantity-preset[data-quantity="${quantity}"]`);
  if (presetButton && presetButton.hasAttribute('data-discount')) {
    discount = parseFloat(presetButton.getAttribute('data-discount')) || 0;
  } else {
    const presetDataItems = Array.from(quantitySelectorBlock?.querySelectorAll('.bk-media-quantity-preset-data') || []);
    presetDataItems.forEach(item => {
      const itemQuantity = parseInt(item.getAttribute('data-quantity'));
      if (itemQuantity && itemQuantity <= quantity && itemQuantity > highestMatchingQuantity) {
        highestMatchingQuantity = itemQuantity;
        if (item.hasAttribute('data-discount')) {
          discount = parseFloat(item.getAttribute('data-discount')) || 0;
        }
      }
    });
  }
  
  if (discount > 0 && discount <= 100) {
    const discountAmountCents = totalCents * (discount / 100);
    const truncatedDiscountCents = Math.floor(discountAmountCents);
    const discountedCents = totalCents - truncatedDiscountCents;
    
    const originalPriceText = formatMoney(totalCents);
    const discountedPriceText = formatMoney(discountedCents);
    const discountText = '-' + discount + '%';
    const priceList = priceBlockContainer?.querySelector('price-list');
    const activeCompareAtPrice = ensureCompareAtPriceElement(priceList, priceBlockSalePrice) || priceBlockCompareAtPrice;
    
    if (originalPriceContainer) {
      originalPriceContainer.textContent = originalPriceText;
      originalPriceContainer.style.display = 'inline-block';
      originalPriceContainer.style.textDecoration = 'line-through';
      originalPriceContainer.style.opacity = '0.6';
    }
    
    if (activeCompareAtPrice) {
      setPriceElementContent(activeCompareAtPrice, originalPriceText);
      activeCompareAtPrice.style.display = '';
      activeCompareAtPrice.classList.add('text-subdued', 'line-through');
    }

    if (priceBlockSalePrice) {
      setPriceElementContent(priceBlockSalePrice, discountedPriceText);
      priceBlockSalePrice.classList.add('text-on-sale');
      priceBlockSalePrice.classList.remove('text-subdued');
    }
    
    if (priceBlockDiscountedUnitPrice && unitPriceElement && unitPriceElement.hasAttribute('data-unit-price')) {
      const unitPriceCents = parseInt(unitPriceElement.getAttribute('data-unit-price'));
      const referenceUnit = unitPriceElement.getAttribute('data-unit-price-measurement-reference-unit') || '';
      const unitDiscountAmountCents = unitPriceCents * (discount / 100);
      const truncatedUnitDiscountCents = Math.floor(unitDiscountAmountCents);
      const discountedUnitPriceCents = unitPriceCents - truncatedUnitDiscountCents;
      const discountedUnitPriceText = formatMoney(discountedUnitPriceCents) + '/' + referenceUnit;
      priceBlockDiscountedUnitPrice.textContent = ' (' + discountedUnitPriceText + ')';
      priceBlockDiscountedUnitPrice.style.display = 'inline';
      
      if (unitPriceElement) {
        unitPriceElement.style.display = 'none';
      }
    } else if (priceBlockDiscountedUnitPrice) {
      priceBlockDiscountedUnitPrice.style.display = 'none';
    }
    
    if (priceBlockDiscountBadge) {
      priceBlockDiscountBadge.textContent = discountText;
      priceBlockDiscountBadge.style.display = 'inline-flex';
    }
    
    if (priceContainer) {
      priceContainer.textContent = discountedPriceText;
    }
  } else {
    const regularPriceText = formatMoney(basePriceCents);
    
    if (originalPriceContainer) {
      originalPriceContainer.style.display = 'none';
      originalPriceContainer.textContent = '';
    }
    
    if (priceBlockDiscountedUnitPrice) {
      priceBlockDiscountedUnitPrice.style.display = 'none';
      priceBlockDiscountedUnitPrice.textContent = '';
    }
    
    if (priceBlockDiscountBadge) {
      priceBlockDiscountBadge.style.display = 'none';
      priceBlockDiscountBadge.textContent = '';
    }
    
    if (priceContainer) {
      priceContainer.textContent = regularPriceText;
    }
    
    if (priceBlockSalePrice) {
      setPriceElementContent(priceBlockSalePrice, regularPriceText);
    }

    updateVariantCompareAtPrice(priceBlockSalePrice, priceBlockCompareAtPrice, basePriceCents, compareAtCents);
    
    if (unitPriceElement && unitPriceElement.hasAttribute('data-unit-price')) {
      const unitPriceCents = parseInt(unitPriceElement.getAttribute('data-unit-price'));
      const referenceUnit = unitPriceElement.getAttribute('data-unit-price-measurement-reference-unit') || '';
      const unitPriceText = formatMoney(unitPriceCents) + '/' + referenceUnit;
      unitPriceElement.textContent = '(' + unitPriceText + ')';
      unitPriceElement.style.display = '';
    }
  }
}

let cachedVariantDataMap = null;
let variantDataScriptContent = null;
let cachedVariantUnitPriceMap = null;
let variantUnitPriceScriptContent = null;
let variantChangeTimeout = null;
let variantChangeAnimationFrame = null;

function getVariantUnitPriceMap() {
  const variantUnitPriceScript = document.querySelector('[data-variant-unit-prices]');
  if (!variantUnitPriceScript) return null;
  
  const currentContent = variantUnitPriceScript.textContent;
  if (currentContent === variantUnitPriceScriptContent && cachedVariantUnitPriceMap) {
    return cachedVariantUnitPriceMap;
  }
  
  try {
    cachedVariantUnitPriceMap = JSON.parse(currentContent);
    variantUnitPriceScriptContent = currentContent;
    return cachedVariantUnitPriceMap;
  } catch (e) {
    console.error('Failed to parse variant unit price data:', e);
    return null;
  }
}

function getVariantDataMap() {
  const variantDataScript = document.querySelector('[data-variant-quantity-labels]');
  if (!variantDataScript) return null;
  
  const currentContent = variantDataScript.textContent;
  if (currentContent === variantDataScriptContent && cachedVariantDataMap) {
    return cachedVariantDataMap;
  }
  
  try {
    cachedVariantDataMap = JSON.parse(currentContent);
    variantDataScriptContent = currentContent;
    return cachedVariantDataMap;
  } catch (e) {
    console.error('Failed to parse variant data:', e);
    return null;
  }
}

function getVariantData(variantId) {
  const variantDataMap = getVariantDataMap();
  if (!variantDataMap) return null;
  
  const variantIdStr = String(variantId);
  let variantData = variantDataMap[variantIdStr];
  
  if (!variantData) {
    const numericKey = Object.keys(variantDataMap).find(key => {
      return String(key) === variantIdStr || parseInt(key) === parseInt(variantIdStr);
    });
    if (numericKey) {
      variantData = variantDataMap[numericKey];
    }
  }
  
  return variantData || null;
}

function getQuantityLabelPrefix() {
  return window.themeVariables?.strings?.quantityLabel || 'Quantity:';
}

function generateQuantityLabel(quantity, variantData) {
  const prefix = getQuantityLabelPrefix();
  if (!variantData || !variantData.title) {
    return `${prefix} ${quantity}`;
  }
  return `${prefix} ${quantity} • ${variantData.title}`;
}

function updateQuantityLabels(variantId) {
  const variantData = getVariantData(variantId);
  if (!variantData) return;
  
  const quantitySelectors = document.querySelectorAll('.product-info__quantity-selector');
  quantitySelectors.forEach(selector => {
    const presetLabels = selector.querySelectorAll('.bk-media-quantity-presets__label-cell[data-auto-label]');
    presetLabels.forEach(cell => {
      const quantity = parseInt(cell.getAttribute('data-quantity'));
      if (quantity) {
        const labelElement = cell.querySelector('.bk-media-quantity-preset__label');
        if (labelElement) {
          const labelText = generateQuantityLabel(quantity, variantData);
          if (labelElement.textContent !== labelText) {
            labelElement.textContent = labelText;
          }
        }
      }
    });
    
    const presetButtons = selector.querySelectorAll('.bk-media-quantity-preset[data-auto-label]');
    presetButtons.forEach(button => {
      const quantity = parseInt(button.getAttribute('data-quantity'));
      if (quantity) {
        const ariaLabel = generateQuantityLabel(quantity, variantData);
        if (button.getAttribute('aria-label') !== ariaLabel) {
          button.setAttribute('aria-label', ariaLabel);
        }
      }
    });
    
    const quantityInput = selector.querySelector('.quantity-selector__input');
    if (quantityInput) {
      updateAccordionDisplay(quantityInput);
    }
  });
}

function syncDisplayForVariant(productInfo, variantId, quantityInput) {
  const accordionContainer = productInfo.querySelector('.bk-media-quantity-presets--accordion');
  if (!accordionContainer) return;
  
  updateAccordionDisplay(quantityInput);
  
  const variantData = getVariantData(variantId);
  if (variantData) {
    updateQuantityLabels(String(variantId));
  }
}

function initQuantityPresets() {
  const accordionContainers = document.querySelectorAll('.bk-media-quantity-presets--accordion');
  
  accordionContainers.forEach(container => {
    if (container.dataset.accordionInitialized) return;
    container.dataset.accordionInitialized = 'true';
    
    const formControl = container.closest('.product-info__quantity-selector');
    if (!formControl) return;
    
    let quantityInput = formControl.querySelector('.quantity-selector__input');
    if (!quantityInput) {
      const presetDisplay = container.querySelector('.bk-media-quantity-preset-display');
      quantityInput = presetDisplay?.querySelector('.quantity-selector__input');
    }
    if (!quantityInput) return;
    
    const presetDisplay = container.querySelector('.bk-media-quantity-preset-display');
    if (!presetDisplay) return;
    
    function syncDisplay() {
      updateAccordionDisplay(quantityInput);
    }
    
    quantityInput.addEventListener('input', syncDisplay);
    quantityInput.addEventListener('change', syncDisplay);
    
    function initializeLabels() {
      const form = quantityInput.closest('form[id^="product-form"]');
      let variantId = null;
      if (form) {
        const variantIdInput = form.querySelector('input[name="id"]');
        if (variantIdInput && variantIdInput.value) {
          variantId = variantIdInput.value;
        }
      }
      
      if (!variantId) {
        const variantDataMap = getVariantDataMap();
        if (variantDataMap) {
          const firstVariantId = Object.keys(variantDataMap)[0];
          if (firstVariantId) {
            variantId = firstVariantId;
          }
        }
      }
      
      if (variantId) {
        requestAnimationFrame(function() {
          updateQuantityLabels(variantId);
        });
      }
    }
    
    initializeLabels();
    syncDisplay();
  });
  
  requestAnimationFrame(function() {
    const quantitySelectors = document.querySelectorAll('.product-info__quantity-selector');
    quantitySelectors.forEach(selector => {
      const accordionContainer = selector.querySelector('.bk-media-quantity-presets--accordion');
      if (!accordionContainer || accordionContainer.dataset.accordionInitialized) {
        let form = null;
        const quantityInput = selector.querySelector('.quantity-selector__input');
        if (quantityInput) {
          const quantityInputFormId = quantityInput.getAttribute('form');
          if (quantityInputFormId) {
            form = document.getElementById(quantityInputFormId);
          }
          if (!form) {
            form = quantityInput.closest('form[id^="product-form"]');
          }
          if (!form) {
            form = document.querySelector('form[is="product-form"]');
          }
        }
        
        let variantId = null;
        if (form) {
          const variantIdInput = form.querySelector('input[name="id"]');
          if (variantIdInput && variantIdInput.value) {
            variantId = variantIdInput.value;
          }
        }
        
        if (variantId) {
          updateQuantityLabels(variantId);
        }
      }
    });
  });
  
  const presetButtons = document.querySelectorAll('.bk-media-quantity-preset');
  
  presetButtons.forEach(button => {
    if (button.dataset.initialized) return;
    
    button.dataset.initialized = 'true';
    
    button.addEventListener('click', function() {
      const quantity = parseInt(this.getAttribute('data-quantity'));
      if (!quantity || isNaN(quantity)) return;
      
      const formControl = this.closest('.product-info__quantity-selector');
      if (!formControl) return;
      
      const quantityInput = formControl.querySelector('.quantity-selector__input');
      if (!quantityInput) return;
      
      const min = parseInt(quantityInput.getAttribute('min')) || 1;
      const max = quantityInput.getAttribute('max') ? parseInt(quantityInput.getAttribute('max')) : null;
      
      let finalQuantity = Math.max(min, quantity);
      if (max !== null) {
        finalQuantity = Math.min(finalQuantity, max);
      }
      
      quantityInput.quantity = finalQuantity;
      
      presetButtons.forEach(btn => {
        btn.removeAttribute('data-selected');
      });
      
      const badgesRow = formControl.querySelector('.bk-media-quantity-presets__badges-row');
      if (badgesRow) {
        const badgeCells = badgesRow.querySelectorAll('.bk-media-quantity-presets__badge-cell');
        badgeCells.forEach(cell => {
          cell.removeAttribute('data-selected');
        });
        const badge = badgesRow.querySelector(`.bk-media-quantity-preset__badge[data-preset-quantity="${quantity}"]`);
        if (badge) {
          badge.closest('.bk-media-quantity-presets__badge-cell')?.setAttribute('data-selected', 'true');
        }
      }
      
      this.setAttribute('data-selected', 'true');
      
      syncPresetSelection(quantityInput);
      updateQuantityPrice(quantityInput);
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  
  const quantityInputs = document.querySelectorAll('.quantity-selector__input');
  
  quantityInputs.forEach(input => {
    if (!input.dataset.presetSync) {
      input.dataset.presetSync = 'true';
      
      input.addEventListener('input', function() {
        syncPresetSelection(this);
        updateQuantityPrice(this);
        updateAccordionDisplay(this);
        updateDiscountBadgeStyles(this);
      });
      
      input.addEventListener('change', function() {
        syncPresetSelection(this);
        updateQuantityPrice(this);
        updateAccordionDisplay(this);
        updateDiscountBadgeStyles(this);
      });
      
      syncPresetSelection(input);
      updateQuantityPrice(input);
      updateAccordionDisplay(input);
      updateDiscountBadgeStyles(input);
    }
  });
  
  document.addEventListener('variant:change', function(event) {
    const variant = event.detail?.variant;
    if (!variant || !variant.price) return;
    
    const formId = event.detail?.formId;
    if (!formId) return;
    
    const form = typeof formId === 'string' ? document.getElementById(formId) : (formId.id ? document.getElementById(formId.id) : formId);
    if (!form) return;
    
    const productInfo = form.closest('.product-info');
    if (!productInfo) return;
    
    if (variantChangeTimeout) {
      clearTimeout(variantChangeTimeout);
      variantChangeTimeout = null;
    }
    
    if (variantChangeAnimationFrame) {
      cancelAnimationFrame(variantChangeAnimationFrame);
      variantChangeAnimationFrame = null;
    }
    
    const formControl = productInfo.querySelector('.form-control[data-variant-price]');
    const priceBlockContainer = productInfo.querySelector('.bk-media-price-preset-container');
    const newPriceCents = variant.price;
    const accordionContainer = productInfo.querySelector('.bk-media-quantity-presets--accordion');
    
    variantChangeAnimationFrame = requestAnimationFrame(function() {
      const quantityInput = formControl ? formControl.querySelector('.quantity-selector__input') : productInfo.querySelector('.quantity-selector__input');
      
      if (formControl) {
        const priceElement = formControl.querySelector('.bk-media-quantity-price');
        if (priceElement) {
          priceElement.setAttribute('data-price', newPriceCents);
          formControl.setAttribute('data-variant-price', newPriceCents);
        }
      }
      
      if (priceBlockContainer) {
        priceBlockContainer.setAttribute('data-variant-price', newPriceCents);
        priceBlockContainer.setAttribute('data-variant-compare-at', variant.compare_at_price || 0);

        const {
          salePrice: priceBlockSalePrice,
          compareAtPrice: priceBlockCompareAtPrice,
          unitPrice: unitPriceElement
        } = getPriceBlockPriceListElements(priceBlockContainer);
        
        if (unitPriceElement && variant.id) {
          const variantUnitPriceMap = getVariantUnitPriceMap();
          if (variantUnitPriceMap && variantUnitPriceMap[variant.id] !== null && variantUnitPriceMap[variant.id] !== undefined) {
            const unitPriceData = variantUnitPriceMap[variant.id];
            unitPriceElement.setAttribute('data-unit-price', unitPriceData.unit_price);
            unitPriceElement.setAttribute('data-unit-price-measurement-reference-unit', unitPriceData.reference_unit);
            const unitPriceText = formatMoney(unitPriceData.unit_price) + '/' + unitPriceData.reference_unit;
            unitPriceElement.textContent = '(' + unitPriceText + ')';
            unitPriceElement.style.display = '';
          } else if (variant.unit_price) {
            unitPriceElement.setAttribute('data-unit-price', variant.unit_price);
            unitPriceElement.setAttribute('data-unit-price-measurement-reference-unit', variant.unit_price_measurement?.reference_unit || '');
            unitPriceElement.style.display = '';
          } else {
            unitPriceElement.style.display = 'none';
          }
        }

        if (priceBlockSalePrice) {
          setPriceElementContent(priceBlockSalePrice, formatMoney(newPriceCents));
        }

        updateVariantCompareAtPrice(
          priceBlockSalePrice,
          priceBlockCompareAtPrice,
          newPriceCents,
          variant.compare_at_price || 0
        );
      }
      
      
      if (quantityInput) {
        updateQuantityPrice(quantityInput, newPriceCents);
        if (accordionContainer) {
          updateAccordionDisplay(quantityInput);
        }
      }
      
      variantChangeTimeout = setTimeout(function() {
        document.querySelectorAll('.bk-media-quantity-presets__discount-badges').forEach(container => {
          if (container.dataset.cyclingIntervalId) {
            clearInterval(parseInt(container.dataset.cyclingIntervalId));
            delete container.dataset.cyclingIntervalId;
          }
          delete container.dataset.cyclingInitialized;
        });
        
        if (variant && variant.id) {
          updateQuantityLabels(String(variant.id));
        }
        
        if (formControl && quantityInput) {
          syncDisplayForVariant(productInfo, variant.id, quantityInput);
          syncPresetSelection(quantityInput);
        }
        
        if (accordionContainer && !accordionContainer.dataset.accordionInitialized) {
          initQuantityPresets();
        }
        
        initDiscountBadgeCycling();
        
        variantChangeTimeout = null;
      }, 0);
    });
  });
}

function updateDiscountBadgeStyles(quantityInput) {
  const currentQuantity = parseInt(quantityInput.value) || 0;
  const formControl = quantityInput.closest('.product-info__quantity-selector');
  if (!formControl) return;
  
  const badgesContainer = formControl.querySelector('.bk-media-quantity-presets__discount-badges');
  if (!badgesContainer) return;
  
  const badges = Array.from(badgesContainer.querySelectorAll('.bk-media-quantity-presets__discount-badge'));
  
  badges.forEach(badge => {
    badge.classList.remove('is-active');
  });
  
  if (currentQuantity <= 0) return;
  
  const reachedBadges = badges.filter(badge => {
    const badgeQuantity = parseInt(badge.getAttribute('data-quantity')) || 0;
    return currentQuantity >= badgeQuantity && badgeQuantity > 0;
  });
  
  if (reachedBadges.length > 0) {
    const highestBadge = reachedBadges.reduce((highest, current) => {
      const highestQuantity = parseInt(highest.getAttribute('data-quantity')) || 0;
      const currentQuantity = parseInt(current.getAttribute('data-quantity')) || 0;
      return currentQuantity > highestQuantity ? current : highest;
    });
    
    highestBadge.classList.add('is-active');
  }
}

function initDiscountBadgeCycling() {
  const discountBadgesContainers = document.querySelectorAll('.bk-media-quantity-presets__discount-badges');
  
  discountBadgesContainers.forEach(container => {
    if (container.dataset.cyclingIntervalId) {
      clearInterval(parseInt(container.dataset.cyclingIntervalId));
      delete container.dataset.cyclingIntervalId;
    }
    
    const badges = container.querySelectorAll('.bk-media-quantity-presets__discount-badge');
    if (badges.length === 0) return;
    
    container.dataset.cyclingInitialized = 'true';
    
    const formControl = container.closest('.product-info__quantity-selector');
    if (formControl) {
      const quantityInput = formControl.querySelector('.quantity-selector__input');
      if (quantityInput) {
        if (!quantityInput.dataset.badgeStylesInitialized) {
          quantityInput.dataset.badgeStylesInitialized = 'true';
          
          const handleQuantityChange = function() {
            updateDiscountBadgeStyles(quantityInput);
          };
          
          quantityInput.addEventListener('input', handleQuantityChange);
          quantityInput.addEventListener('change', handleQuantityChange);
        }
        updateDiscountBadgeStyles(quantityInput);
      }
    }
    
    const badgeTexts = [];
    badges.forEach((badge) => {
      const percentText = badge.querySelector('.bk-media-quantity-presets__discount-badge-percent');
      const quantityText = badge.querySelector('.bk-media-quantity-presets__discount-badge-quantity');
      
      if (!percentText || !quantityText) return;
      
      percentText.classList.remove('is-hidden');
      quantityText.classList.add('is-hidden');
      badgeTexts.push({ percentText, quantityText, badge });
    });
    
    if (badgeTexts.length === 0) return;
    
    let showingPercent = true;
    
    function cycleAllBadges() {
      badgeTexts.forEach(({ percentText, quantityText, badge }) => {
        if (!badge.isConnected) return;
        
        if (showingPercent) {
          percentText.classList.add('is-hidden');
          quantityText.classList.remove('is-hidden');
        } else {
          quantityText.classList.add('is-hidden');
          percentText.classList.remove('is-hidden');
        }
      });
      
      showingPercent = !showingPercent;
    }
    
    const intervalId = setInterval(cycleAllBadges, 3000);
    container.dataset.cyclingIntervalId = intervalId.toString();
  });
}

function syncPresetSelection(quantityInput) {
  const currentQuantity = parseInt(quantityInput.value) || 0;
  const formControl = quantityInput.closest('.product-info__quantity-selector');
  if (!formControl) return;
  
  const presetButtons = formControl.querySelectorAll('.bk-media-quantity-preset');
  
  presetButtons.forEach(button => {
    const presetQuantity = parseInt(button.getAttribute('data-quantity'));
    if (presetQuantity === currentQuantity) {
      button.setAttribute('data-selected', 'true');
    } else {
      button.removeAttribute('data-selected');
    }
  });

  const badgesRow = formControl.querySelector('.bk-media-quantity-presets__badges-row');
  if (badgesRow) {
    const badgeCells = badgesRow.querySelectorAll('.bk-media-quantity-presets__badge-cell');
    badgeCells.forEach(cell => {
      cell.removeAttribute('data-selected');
    });
    const badge = badgesRow.querySelector(`.bk-media-quantity-preset__badge[data-preset-quantity="${currentQuantity}"]`);
    if (badge) {
      badge.closest('.bk-media-quantity-presets__badge-cell')?.setAttribute('data-selected', 'true');
    }
  }
}

// ========================================
// VARIANT ADDED CART BUTTON
// ========================================

function initVariantAddedCartButton() {
  function handleCartButtonClick(event) {
    const button = event.target.closest('.quick-buy-drawer__info [aria-controls="cart-drawer"]');
    if (!button) return;
    
    const cartDrawerId = button.getAttribute('aria-controls');
    if (cartDrawerId !== 'cart-drawer') return;
    
    event.preventDefault();
    event.stopPropagation();
    
    const cartDrawer = document.getElementById('cart-drawer') || document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.show !== 'function') return;
    
    const quickBuyDrawer = button.closest('quick-buy-drawer');
    if (quickBuyDrawer && typeof quickBuyDrawer.hide === 'function') {
      quickBuyDrawer.hide().then(() => {
        cartDrawer.show();
      });
    } else {
      cartDrawer.show();
    }
  }
  
  document.addEventListener('click', handleCartButtonClick, true);
}

// ========================================
// PRESETS POPUP FUNCTIONALITY
// ========================================

function initPresetsPopup() {
  const infoRows = document.querySelectorAll('.bk-media-quantity-presets__info-row--clickable');
  
  infoRows.forEach(row => {
    if (row.dataset.popupInitialized) return;
    
    row.dataset.popupInitialized = 'true';
    
    const presetsContainer = row.closest('.bk-media-quantity-presets');
    if (!presetsContainer) return;
    
    const popupId = presetsContainer.querySelector('.bk-media-quantity-presets__popup')?.id;
    if (!popupId) return;
    
    const popup = document.getElementById(popupId);
    if (!popup) return;
    
    const closeButton = popup.querySelector('.bk-media-quantity-presets__popup-close');
    const overlay = popup.querySelector('.bk-media-quantity-presets__popup-overlay');
    
    function openPopup(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      popup.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    
    function closePopup(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      popup.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    
    row.addEventListener('click', openPopup);
    row.addEventListener('touchend', function(e) {
      e.preventDefault();
      openPopup();
    });
    
    if (closeButton) {
      closeButton.addEventListener('click', closePopup);
      closeButton.addEventListener('touchend', function(e) {
        e.preventDefault();
        closePopup();
      });
    }
    
    if (overlay) {
      overlay.addEventListener('click', closePopup);
      overlay.addEventListener('touchend', function(e) {
        e.preventDefault();
        closePopup();
      });
    }
    
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) {
        closePopup();
      }
    });
  });
}

// ========================================
// MOBILE NAVIGATION PANEL SWITCHING FIX
// ========================================

function initMobileNavPanelSwitching() {
  const navigationDrawers = document.querySelectorAll('navigation-drawer:not([mega-menu])');
  
  navigationDrawers.forEach(drawer => {
    const buttons = drawer.querySelectorAll('.bk-media-mobile-nav__menu-item[data-panel]');
    
    buttons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        
        const targetPanelIndex = parseInt(this.getAttribute('data-panel'));
        const panels = drawer.querySelectorAll('.panel');
        
        if (!panels[targetPanelIndex]) {
          return;
        }
        
        let currentVisiblePanel = 0;
        panels.forEach((panel, index) => {
          const style = window.getComputedStyle(panel);
          if (style.opacity !== '0' && style.visibility !== 'hidden' && !panel.hasAttribute('hidden')) {
            currentVisiblePanel = index;
          }
        });
        
        const panelToHide = panels[currentVisiblePanel];
        const panelToShow = panels[targetPanelIndex];
        
        if (!panelToShow || currentVisiblePanel === targetPanelIndex) {
          return;
        }
        
        const isRTL = document.dir === 'rtl';
        const hideTransform = isRTL ? 'translateX(100%)' : 'translateX(-100%)';
        const showTransform = isRTL ? 'translateX(-100%)' : 'translateX(100%)';
        
        panelToShow.removeAttribute('hidden');
        const panelWrapper = panelToShow.querySelector('.panel__wrapper');
        if (panelWrapper) {
          panelWrapper.removeAttribute('hidden');
        }
        
        if (typeof timeline9 !== 'undefined') {
          const timeline = [
            [
              panelToHide,
              {
                transform: ['translateX(0%)', hideTransform],
                opacity: [1, 0],
                visibility: ['visible', 'hidden']
              },
              { duration: 0.3, opacity: { at: '+0.3' }, transform: { at: '+0.3' } }
            ],
            'panelHidden',
            [
              panelToShow,
              {
                transform: [showTransform, 'translateX(0%)'],
                opacity: [0, 1],
                visibility: ['hidden', 'visible']
              },
              { at: '<', transform: { duration: 0.3 } }
            ]
          ];
          timeline9(timeline);
        } else {
          panelToHide.style.opacity = '0';
          panelToHide.style.visibility = 'hidden';
          panelToHide.style.transform = hideTransform;
          panelToShow.style.opacity = '1';
          panelToShow.style.visibility = 'visible';
          panelToShow.style.transform = 'translateX(0%)';
        }
      }, true);
    });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(initMobileNavPanelSwitching, 100);
  initMobileAccordionFilters();
  
  document.addEventListener('shopify:section:load', function() {
    setTimeout(initMobileNavPanelSwitching, 100);
    initMobileAccordionFilters();
  });
});

// ========================================
// MOBILE ACCORDION FILTERS - DRAWER TRIGGERS
// ========================================

function initMobileAccordionFilters() {
  const drawers = document.querySelectorAll('.bk-media-mobile-filter-drawer');
  
  drawers.forEach(drawer => {
    const mobileOpening = drawer.getAttribute('mobile-opening');
    if (mobileOpening && window.matchMedia('(max-width: 699px)').matches) {
      Object.defineProperty(drawer, 'openFrom', {
        get: function() {
          return mobileOpening;
        },
        configurable: true
      });
    }
  });
  
  // Use event delegation on document to catch all changes, even after DOM updates
  document.addEventListener('change', function(e) {
    const target = e.target;
    if (target.matches('.bk-media-mobile-filter-drawer .checkbox-pill-input, .bk-media-mobile-filter-drawer .checkbox, .bk-media-mobile-filter-drawer input[type="radio"], .bk-media-mobile-filter-drawer input[type="checkbox"]')) {
      const drawer = target.closest('.bk-media-mobile-filter-drawer');
      if (drawer && drawer.open) {
        setTimeout(() => {
          if (drawer.open) {
            drawer.hide();
          }
        }, 150);
      }
    }
  });
}

// ========================================
// INFO SECTION SCROLL TO PRODUCT INFO
// ========================================

function initInfoSectionScrollToProductInfo() {
  const scrollButtons = document.querySelectorAll('[data-bk-media-scroll-to-product-info]');
  
  scrollButtons.forEach(button => {
    if (button.dataset.scrollInitialized) return;
    button.dataset.scrollInitialized = 'true';
    
    button.addEventListener('click', function(e) {
      const productInfo = document.querySelector('.product-info');
      if (!productInfo) return;
      
      e.preventDefault();
      
      const headerOffset = 100;
      const elementPosition = productInfo.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initInfoSectionScrollToProductInfo();
});

document.addEventListener('shopify:section:load', function() {
  initInfoSectionScrollToProductInfo();
});

// ========================================
// TIMER BLOCK
// ========================================

function initTimerBlock(timerElement) {
  var daysEl = timerElement.querySelector('.bk-media-timer-block__timer-days');
  var hoursEl = timerElement.querySelector('.bk-media-timer-block__timer-hours');
  var minutesEl = timerElement.querySelector('.bk-media-timer-block__timer-minutes');
  var secondsEl = timerElement.querySelector('.bk-media-timer-block__timer-seconds');
  var timerBlock = timerElement.closest('.bk-media-timer-block');
  var progressBarFill = timerBlock ? timerBlock.querySelector('.bk-media-timer-block__progress-bar-fill') : null;

  if (!daysEl || !hoursEl || !minutesEl || !secondsEl) {
    console.warn('Timer block elements not found', timerElement);
    return;
  }

  var metaobjectDate = (timerElement.getAttribute('data-metaobject-date') || '').trim();
  var metaobjectStartDate = (timerElement.getAttribute('data-metaobject-start-date') || '').trim();
  var endTime;

  function parseDateToTimestamp(dateString) {
    if (!dateString) return null;
    var trimmed = dateString.trim();
    if (!trimmed) return null;

    var numeric = parseInt(trimmed, 10);
    if (!isNaN(numeric) && numeric > 0) {
      return numeric < 10000000000 ? numeric * 1000 : numeric;
    }

    var parsed = new Date(trimmed);
    if (!isNaN(parsed.getTime())) return parsed.getTime();

    return null;
  }

  if (metaobjectDate) {
    endTime = parseDateToTimestamp(metaobjectDate);
    if (endTime == null) {
      console.warn('Failed to parse metaobject date:', metaobjectDate);
      return;
    }
  } else {
    return;
  }

  function updateTimer() {
    var now = Date.now();
    var remaining = Math.max(0, Math.floor((endTime - now) / 1000));

    var days = Math.floor(remaining / 86400);
    remaining = remaining % 86400;
    var hours = Math.floor(remaining / 3600);
    remaining = remaining % 3600;
    var mins = Math.floor(remaining / 60);
    var secs = remaining % 60;

    daysEl.textContent = days;
    hoursEl.textContent = hours;
    minutesEl.textContent = mins;
    secondsEl.textContent = secs;

    if (progressBarFill && metaobjectStartDate) {
      var parsedStartDate = parseDateToTimestamp(metaobjectStartDate);
      if (parsedStartDate !== null && endTime) {
        var calculatedStartTime = parsedStartDate;
        var totalDurationSeconds = Math.floor((endTime - parsedStartDate) / 1000);

        if (totalDurationSeconds > 0) {
          var elapsedSeconds = Math.max(0, Math.floor((now - calculatedStartTime) / 1000));
          var remainingSeconds = Math.max(0, totalDurationSeconds - elapsedSeconds);
          var progress = 0;

          if (elapsedSeconds <= totalDurationSeconds) {
            progress = (remainingSeconds / totalDurationSeconds) * 100;
          }

          progressBarFill.style.width = Math.min(100, Math.max(0, progress)) + '%';
        }
      }
    }
  }

  updateTimer();
  var interval = setInterval(updateTimer, 1000);
  timerElement.dataset.intervalId = interval;
}

function initTimerBlocks() {
  document.querySelectorAll('.bk-media-timer-block__timer').forEach(function(timer) {
    var existingIntervalId = timer.dataset.intervalId;
    if (existingIntervalId) {
      clearInterval(parseInt(existingIntervalId));
      delete timer.dataset.intervalId;
    }

    timer.dataset.initialized = 'true';
    try {
      initTimerBlock(timer);
    } catch (error) {
      console.error('Error initializing timer block:', error, timer);
      timer.dataset.initialized = 'false';
    }
  });
}

function copyCodeToClipboard(code, onSuccess) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(code).then(onSuccess).catch(function(err) {
      console.error('Failed to copy code:', err);
    });
    return;
  }

  var textArea = document.createElement('textarea');
  textArea.value = code;
  textArea.style.position = 'fixed';
  textArea.style.opacity = '0';
  document.body.appendChild(textArea);
  textArea.select();

  try {
    document.execCommand('copy');
    onSuccess();
  } catch (err) {
    console.error('Failed to copy code:', err);
  } finally {
    document.body.removeChild(textArea);
  }
}

function initTimerCopyButtons() {
  document.querySelectorAll('button.bk-media-timer-block__code-badge').forEach(function(button) {
    if (button.dataset.copyInitialized) return;
    button.dataset.copyInitialized = 'true';

    button.addEventListener('click', function() {
      var code = this.dataset.code;
      if (!code) return;

      var textEl = this.querySelector('.bk-media-timer-block__code-text');
      var originalText = textEl ? textEl.textContent : '';
      var originalBadgeText = this.textContent;
      var self = this;

      function showCopiedFeedback() {
        if (textEl) {
          textEl.textContent = 'Copied!';
        } else {
          self.textContent = 'Copied!';
        }

        setTimeout(function() {
          if (textEl) {
            textEl.textContent = originalText;
          } else {
            self.textContent = originalBadgeText;
          }
        }, 2000);
      }

      copyCodeToClipboard(code, showCopiedFeedback);
    });
  });
}

function initRabattcodesCopyButtons() {
  document.querySelectorAll('button.bk-media-rabattcodes__copy').forEach(function(button) {
    if (button.dataset.copyInitialized) return;
    button.dataset.copyInitialized = 'true';

    button.addEventListener('click', function() {
      var code = this.dataset.code;
      if (!code) return;

      var actionEl = this.querySelector('.bk-media-rabattcodes__coupon-action');
      var labelEl = this.querySelector('.bk-media-rabattcodes__copy-label');
      var feedbackEl = actionEl || labelEl;
      var originalText = feedbackEl ? feedbackEl.textContent : this.textContent;
      var self = this;

      function showCopiedFeedback() {
        if (feedbackEl) {
          feedbackEl.textContent = 'Copied!';
        } else {
          self.textContent = 'Copied!';
        }

        setTimeout(function() {
          if (feedbackEl) {
            feedbackEl.textContent = originalText;
          } else {
            self.textContent = originalText;
          }
        }, 2000);
      }

      copyCodeToClipboard(code, showCopiedFeedback);
    });
  });
}

var timerCelebrationPlaying = false;
var timerCelebrationColors = ['#F9D354', '#DC5B5B', '#57FFFF', '#EC4899', '#124B3A', '#FFFFFF', '#FF6B35'];
var TIMER_CELEBRATION_PAGELOAD_KEY = 'bk-media:timer-celebration-seen:pageload';
var TIMER_CELEBRATION_PDP_KEY = 'bk-media:timer-celebration-seen:pdp';

function isTimerCelebrationEnabled() {
  return !!(window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.enableTimerCelebration);
}

function hasSeenTimerCelebration(key) {
  try {
    return localStorage.getItem(key) === '1';
  } catch (error) {
    return false;
  }
}

function markTimerCelebrationSeen(key) {
  try {
    localStorage.setItem(key, '1');
  } catch (error) {}
}

function hasTimerBlockOnPage() {
  return document.querySelector('.bk-media-timer-wrapper') !== null;
}

function getTimerCelebrationContextKey() {
  return hasTimerBlockOnPage() ? TIMER_CELEBRATION_PDP_KEY : TIMER_CELEBRATION_PAGELOAD_KEY;
}

function shouldPlayTimerCelebration() {
  if (!isTimerCelebrationEnabled()) return false;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
  return !hasSeenTimerCelebration(getTimerCelebrationContextKey());
}

function timerCelebrationRandom(min, max) {
  return min + Math.random() * (max - min);
}

function timerCelebrationPickColor() {
  return timerCelebrationColors[Math.floor(Math.random() * timerCelebrationColors.length)];
}

function timerCelebrationCreateConfetti(overlay) {
  var i;

  for (i = 0; i < 90; i++) {
    var piece = document.createElement('div');
    piece.className = 'bk-media-timer-celebration__confetti';
    piece.style.setProperty('--bk-confetti-left', timerCelebrationRandom(0, 100) + '%');
    piece.style.setProperty('--bk-confetti-color', timerCelebrationPickColor());
    piece.style.setProperty('--bk-confetti-w', timerCelebrationRandom(6, 12) + 'px');
    piece.style.setProperty('--bk-confetti-h', timerCelebrationRandom(8, 16) + 'px');
    piece.style.setProperty('--bk-confetti-drift', timerCelebrationRandom(-80, 80) + 'px');
    piece.style.setProperty('--bk-confetti-rot', timerCelebrationRandom(360, 1080) + 'deg');
    piece.style.setProperty('--bk-confetti-dur', timerCelebrationRandom(2.5, 4) + 's');
    piece.style.setProperty('--bk-confetti-delay', timerCelebrationRandom(0, 0.6) + 's');
    overlay.appendChild(piece);
  }

  for (i = 0; i < 30; i++) {
    var sway = document.createElement('div');
    sway.className = 'bk-media-timer-celebration__confetti bk-media-timer-celebration__confetti--sway';
    sway.style.setProperty('--bk-confetti-left', timerCelebrationRandom(0, 100) + '%');
    sway.style.setProperty('--bk-confetti-color', timerCelebrationPickColor());
    sway.style.setProperty('--bk-confetti-w', timerCelebrationRandom(6, 10) + 'px');
    sway.style.setProperty('--bk-confetti-h', timerCelebrationRandom(10, 18) + 'px');
    sway.style.setProperty('--bk-confetti-drift', timerCelebrationRandom(-60, 60) + 'px');
    sway.style.setProperty('--bk-confetti-sway', timerCelebrationRandom(30, 70) + 'px');
    sway.style.setProperty('--bk-confetti-rot', timerCelebrationRandom(360, 900) + 'deg');
    sway.style.setProperty('--bk-confetti-dur', timerCelebrationRandom(2.8, 4.2) + 's');
    sway.style.setProperty('--bk-confetti-delay', timerCelebrationRandom(0, 0.5) + 's');
    overlay.appendChild(sway);
  }

  for (i = 0; i < 35; i++) {
    var streamer = document.createElement('div');
    streamer.className = 'bk-media-timer-celebration__confetti bk-media-timer-celebration__confetti--streamer';
    streamer.style.setProperty('--bk-confetti-left', timerCelebrationRandom(0, 100) + '%');
    streamer.style.setProperty('--bk-confetti-color', timerCelebrationPickColor());
    streamer.style.setProperty('--bk-confetti-h', timerCelebrationRandom(20, 36) + 'px');
    streamer.style.setProperty('--bk-confetti-drift', timerCelebrationRandom(-50, 50) + 'px');
    streamer.style.setProperty('--bk-confetti-rot', timerCelebrationRandom(180, 540) + 'deg');
    streamer.style.setProperty('--bk-confetti-dur', timerCelebrationRandom(3, 4.5) + 's');
    streamer.style.setProperty('--bk-confetti-delay', timerCelebrationRandom(0, 0.4) + 's');
    overlay.appendChild(streamer);
  }
}

function timerCelebrationCreateFirework(overlay, leftPct, index) {
  var burst = document.createElement('div');
  burst.className = 'bk-media-timer-celebration__burst';
  burst.style.setProperty('--bk-burst-left', leftPct + '%');

  var apexVh = timerCelebrationRandom(25, 75);
  var rocketDelay = index * 0.08 + timerCelebrationRandom(0, 0.2);
  var rocketDur = timerCelebrationRandom(0.9, 1.4);
  var burstDelay = rocketDelay + rocketDur * 0.85;

  burst.style.setProperty('--bk-apex-vh', apexVh + 'vh');
  burst.style.setProperty('--bk-rocket-delay', rocketDelay + 's');
  burst.style.setProperty('--bk-rocket-dur', rocketDur + 's');
  burst.style.setProperty('--bk-burst-delay', burstDelay + 's');
  burst.style.setProperty('--bk-wobble', timerCelebrationRandom(4, 12) + 'px');

  var shell = document.createElement('div');
  shell.className = 'bk-media-timer-celebration__rocket-shell';
  burst.appendChild(shell);

  var flame = document.createElement('div');
  flame.className = 'bk-media-timer-celebration__rocket-flame';
  shell.appendChild(flame);

  var glow = document.createElement('div');
  glow.className = 'bk-media-timer-celebration__rocket-glow';
  shell.appendChild(glow);

  var tail = document.createElement('div');
  tail.className = 'bk-media-timer-celebration__rocket-tail';
  shell.appendChild(tail);

  var e;
  for (e = 0; e < 16; e++) {
    var ember = document.createElement('div');
    ember.className = 'bk-media-timer-celebration__ember';
    ember.style.setProperty('--bk-ember-delay', (rocketDelay + e * 0.04) + 's');
    ember.style.setProperty('--bk-ember-x', timerCelebrationRandom(-24, 24) + 'px');
    ember.style.setProperty('--bk-ember-y', timerCelebrationRandom(20, 50) + 'px');
    ember.style.setProperty('--bk-ember-color', timerCelebrationPickColor());
    shell.appendChild(ember);
  }

  var flash = document.createElement('div');
  flash.className = 'bk-media-timer-celebration__flash';
  burst.appendChild(flash);

  var ring = document.createElement('div');
  ring.className = 'bk-media-timer-celebration__burst-ring';
  burst.appendChild(ring);

  var s;
  for (s = 0; s < 32; s++) {
    var spark = document.createElement('div');
    spark.className = 'bk-media-timer-celebration__spark';
    if (s % 5 === 0) {
      spark.classList.add('bk-media-timer-celebration__spark--star');
    }
    var angle = (360 / 32) * s + timerCelebrationRandom(-8, 8);
    spark.style.setProperty('--bk-spark-angle', angle + 'deg');
    spark.style.setProperty('--bk-spark-dist', timerCelebrationRandom(40, 120) + 'px');
    spark.style.setProperty('--bk-spark-color', timerCelebrationPickColor());
    spark.style.setProperty('--bk-spark-delay', burstDelay + 's');
    spark.style.setProperty('--bk-spark-gravity', timerCelebrationRandom(-30, 30) + 'px');
    burst.appendChild(spark);
  }

  overlay.appendChild(burst);
}

function playTimerCelebration() {
  if (timerCelebrationPlaying) return;
  if (!shouldPlayTimerCelebration()) return;

  timerCelebrationPlaying = true;
  markTimerCelebrationSeen(getTimerCelebrationContextKey());

  var overlay = document.createElement('div');
  overlay.className = 'bk-media-timer-celebration';
  overlay.setAttribute('aria-hidden', 'true');

  var screenFlash = document.createElement('div');
  screenFlash.className = 'bk-media-timer-celebration__screen-flash';
  overlay.appendChild(screenFlash);

  timerCelebrationCreateConfetti(overlay);

  [8, 18, 30, 42, 52, 64, 76, 86, 94, 50].forEach(function(leftPct, index) {
    timerCelebrationCreateFirework(overlay, leftPct, index);
  });

  document.body.appendChild(overlay);

  setTimeout(function() {
    if (overlay.parentNode) overlay.remove();
    timerCelebrationPlaying = false;
  }, 4500);
}

function initGlobalTimerCelebration() {
  playTimerCelebration();
}

function initializeTimerBlocks() {
  initTimerBlocks();
  initTimerCopyButtons();
  initRabattcodesCopyButtons();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initializeTimerBlocks();
    initGlobalTimerCelebration();
  });
} else {
  setTimeout(function() {
    initializeTimerBlocks();
    initGlobalTimerCelebration();
  }, 100);
}

document.addEventListener('shopify:section:load', function() {
  setTimeout(function() {
    initializeTimerBlocks();
    initGlobalTimerCelebration();
  }, 100);
});

document.addEventListener('product:rerender', function() {
  setTimeout(function() {
    initializeTimerBlocks();
    initGlobalTimerCelebration();
  }, 100);
});

// ========================================
// ETRUSTED RATING VISIBILITY
// ========================================

function elementHasVisibleLayout(element) {
  if (!element) return false;

  var style = window.getComputedStyle(element);
  if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;

  var clientRects = element.getClientRects();
  for (var i = 0; i < clientRects.length; i++) {
    if (clientRects[i].width >= 1 && clientRects[i].height >= 1) return true;
  }

  var rect = element.getBoundingClientRect();
  return rect.width >= 1 && rect.height >= 1;
}

function hasJudgemeRatingRendered(container) {
  var badge = container.querySelector('.jdgm-preview-badge');
  var widgetWrap = container.querySelector('.bk-media-judge-me-rating__widget');

  if (!badge) return false;
  if (badge.querySelector('.jdgm-prev-badge__stars, .jdgm-star')) return true;

  var badgeText = (badge.textContent || '').trim();
  if (badgeText && !/no reviews|keine bewertungen/i.test(badgeText)) {
    if (/\d+[.,]\d+/.test(badgeText) || /\([1-9]\d*\)/.test(badgeText)) return true;
  }

  if (elementHasVisibleLayout(badge)) return true;
  if (elementHasVisibleLayout(widgetWrap)) return true;
  if (container.getBoundingClientRect().height >= 10) return true;

  return false;
}

function refreshJudgemeBadges() {
  if (typeof window.jdgm !== 'undefined' && window.jdgm.customize && typeof window.jdgm.customize.badges === 'function') {
    window.jdgm.customize.badges();
  }
}

function initJudgemeRatingVisibility() {
  document.querySelectorAll('.bk-media-judge-me-rating:not(.bk-media-judge-me-rating--revealed):not(.bk-media-judge-me-rating--empty)').forEach(function(container) {
    if (container.dataset.ratingCheckInit === 'true') return;
    container.dataset.ratingCheckInit = 'true';

    var badge = container.querySelector('.jdgm-preview-badge');
    if (!badge) {
      container.classList.add('bk-media-judge-me-rating--empty');
      return;
    }

    function revealRatingBlock() {
      container.classList.add('bk-media-judge-me-rating--revealed');
      container.classList.remove('bk-media-judge-me-rating--empty');
      cleanup();
    }

    function markEmpty() {
      if (container.classList.contains('bk-media-judge-me-rating--revealed')) return;
      container.classList.add('bk-media-judge-me-rating--empty');
      cleanup();
    }

    function cleanup() {
      if (container._ratingResizeObserver) container._ratingResizeObserver.disconnect();
      if (container._ratingMutationObserver) container._ratingMutationObserver.disconnect();
      if (container._ratingPoll) clearInterval(container._ratingPoll);
      if (container._ratingTimeout) clearTimeout(container._ratingTimeout);
    }

    function checkAndReveal() {
      if (hasJudgemeRatingRendered(container)) {
        revealRatingBlock();
        return true;
      }
      return false;
    }

    if (typeof ResizeObserver !== 'undefined') {
      container._ratingResizeObserver = new ResizeObserver(function() {
        checkAndReveal();
      });
      container._ratingResizeObserver.observe(container);
      container._ratingResizeObserver.observe(badge);

      var widgetWrap = container.querySelector('.bk-media-judge-me-rating__widget');
      if (widgetWrap) container._ratingResizeObserver.observe(widgetWrap);
    }

    container._ratingMutationObserver = new MutationObserver(function() {
      setTimeout(checkAndReveal, 50);
    });
    container._ratingMutationObserver.observe(badge, { attributes: true, childList: true, subtree: true, characterData: true });

    var attempts = 0;
    container._ratingPoll = setInterval(function() {
      attempts += 1;
      if (checkAndReveal() || attempts >= 150) {
        clearInterval(container._ratingPoll);
      }
    }, 200);

    refreshJudgemeBadges();
    setTimeout(refreshJudgemeBadges, 100);
    setTimeout(refreshJudgemeBadges, 500);
    setTimeout(refreshJudgemeBadges, 1500);
    setTimeout(refreshJudgemeBadges, 3000);

    container._ratingTimeout = setTimeout(function() {
      if (!container.classList.contains('bk-media-judge-me-rating--revealed')) {
        markEmpty();
      }
    }, 30000);

    checkAndReveal();
  });

  refreshJudgemeBadges();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initJudgemeRatingVisibility);
} else {
  initJudgemeRatingVisibility();
}

document.addEventListener('shopify:section:load', function() {
  setTimeout(initJudgemeRatingVisibility, 100);
  setTimeout(refreshJudgemeBadges, 100);
});

document.addEventListener('product:rerender', function() {
  setTimeout(initJudgemeRatingVisibility, 100);
  setTimeout(refreshJudgemeBadges, 100);
});

// ========================================
// PERSONALIZED TIMELINE
// ========================================

const BK_MEDIA_WEIGHT_RESULT_KEY = 'bk-media-weight-result';
const WF_MOOD_COUNT = 4;
const PERSONALIZED_TAB_STEP_SCALE = 1;

function createWeightFigure(root) {
  var layers = root.querySelectorAll('[data-wf-mood]');
  if (!layers.length) return null;

  var idx = 0;

  function showLayer(layer) {
    layers.forEach(function(el) {
      var isVisible = el === layer;
      el.classList.toggle('is-visible', isVisible);
      el.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    });
  }

  function setStep(i) {
    i = Math.max(0, Math.min(WF_MOOD_COUNT - 1, i | 0));
    idx = i;
    root.setAttribute('data-step', String(i));
    showLayer(root.querySelector('[data-wf-mood="' + i + '"]'));
  }

  var controller = {
    setStep: setStep,
    getStep: function() { return idx; },
    count: WF_MOOD_COUNT
  };

  idx = Math.max(0, Math.min(WF_MOOD_COUNT - 1, parseInt(root.getAttribute('data-step') || '0', 10) || 0));
  showLayer(root.querySelector('[data-wf-mood="' + idx + '"]'));
  root.setAttribute('data-step', String(idx));
  root.controller = controller;

  return controller;
}

function initWeightFigures() {
  document.querySelectorAll('.wf:not([data-wf-initialized])').forEach(function(el) {
    var controller = createWeightFigure(el);
    if (controller) {
      el.setAttribute('data-wf-initialized', 'true');
    }
  });
}

function weightToFigureStep() {
  // Calculator data always starts the recovery journey at the weakest mood.
  return 0;
}

function personalizedFigureStep(baseStep, tabIndex, tabStepScale) {
  var scale = parseFloat(tabStepScale) || PERSONALIZED_TAB_STEP_SCALE;
  return Math.min(WF_MOOD_COUNT - 1, baseStep + Math.round(tabIndex * scale));
}

function initPersonalizedResults() {
  var sections = document.querySelectorAll('[data-bk-media-personalized]');
  sections.forEach(function(section) {
    if (section.getAttribute('data-personalized-initialized') === 'true') return;
    section.setAttribute('data-personalized-initialized', 'true');

    var figureEl = section.querySelector('[data-weight-figure]');
    var selectors = section.querySelectorAll('[data-personalized-selector]');
    var cards = section.querySelectorAll('[data-personalized-card]');
    var useCalculator = section.getAttribute('data-use-calculator') === 'true';
    var startingFigureStep = Math.max(0, Math.min(WF_MOOD_COUNT - 1, parseInt(section.getAttribute('data-starting-figure-step') || '0', 10) || 0));
    var tabStepScale = section.getAttribute('data-tab-step-scale') || String(PERSONALIZED_TAB_STEP_SCALE);
    var baseStep = startingFigureStep;
    var activeTab = 0;

    function applyFigureStep(tabIndex) {
      if (!figureEl || !figureEl.controller) return;
      figureEl.controller.setStep(personalizedFigureStep(baseStep, tabIndex, tabStepScale));
    }

    function updateFromWeight(data) {
      if (useCalculator && data && data.weight) {
        baseStep = weightToFigureStep(data.weight);
      } else {
        baseStep = startingFigureStep;
      }
      applyFigureStep(activeTab);
    }

    function selectOption(index) {
      activeTab = index;
      selectors.forEach(function(sel, i) {
        sel.classList.toggle('is-selected', i === index);
      });
      cards.forEach(function(card, i) {
        card.hidden = i !== index;
      });
      applyFigureStep(index);

      var selectedSelector = selectors[index];
      var selectorsWrap = section.querySelector('.bk-media-personalized__selectors-wrap');
      if (selectedSelector && selectorsWrap) {
        var wrapRect = selectorsWrap.getBoundingClientRect();
        var selRect = selectedSelector.getBoundingClientRect();
        var scrollLeft = selectorsWrap.scrollLeft + (selRect.left - wrapRect.left) - (wrapRect.width - selRect.width) / 2;
        selectorsWrap.scrollTo({ left: scrollLeft, behavior: 'smooth' });
      }
    }

    selectors.forEach(function(sel, i) {
      sel.addEventListener('click', function() { selectOption(i); });
    });

    selectOption(0);

    if (useCalculator) {
      var saved = sessionStorage.getItem(BK_MEDIA_WEIGHT_RESULT_KEY);
      if (saved) {
        try {
          updateFromWeight(JSON.parse(saved));
        } catch (e) {
          updateFromWeight(null);
        }
      } else {
        updateFromWeight(null);
      }

      document.addEventListener('bk-media:weight-calculated', function(e) {
        updateFromWeight(e.detail);
      });
    } else {
      updateFromWeight(null);
    }
  });
}

function initBkMediaPersonalized() {
  initWeightFigures();
  initPersonalizedResults();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBkMediaPersonalized, { once: true });
} else {
  initBkMediaPersonalized();
}

document.addEventListener('shopify:section:load', function() {
  document.querySelectorAll('[data-bk-media-personalized]').forEach(function(section) {
    section.removeAttribute('data-personalized-initialized');
  });
  document.querySelectorAll('.wf[data-wf-initialized]').forEach(function(el) {
    el.removeAttribute('data-wf-initialized');
  });
  initBkMediaPersonalized();
});
/* bk-media-sparset-builder start */

function getCartDrawerSectionId(cartDrawer) {
  if (!cartDrawer) return null;

  const section = cartDrawer.closest('.shopify-section');
  if (section?.id?.startsWith('shopify-section-')) {
    return section.id.replace('shopify-section-', '');
  }

  return cartDrawer.getAttribute('data-section-id') || 'cart-drawer';
}

async function fetchCartDrawerSectionMarkup(sectionId) {
  const response = await fetch(`${window.Shopify.routes.root}?section_id=${encodeURIComponent(sectionId)}`);
  if (!response.ok) {
    throw new Error('Failed to fetch cart drawer section');
  }

  const html = await response.text();
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  const cartDrawer = tempDiv.querySelector('#cart-drawer, cart-drawer');
  return cartDrawer ? cartDrawer.outerHTML : html;
}

async function attachCartDrawerSections(cartContent, cartDrawer) {
  if (!cartDrawer || !cartContent) return cartContent;

  const sectionId = getCartDrawerSectionId(cartDrawer);
  if (!sectionId) return cartContent;

  if (!cartContent.sections) cartContent.sections = {};
  cartContent.sections[sectionId] = await fetchCartDrawerSectionMarkup(sectionId);
  return cartContent;
}

function initBkMediaSparsetBuilder(root) {
  if (!root || root._bkMediaSparsetInitialized) return;

  const configScript = root.querySelector('[data-sparset-config]');
  if (!configScript) return;

  let config = {};
  try {
    config = JSON.parse(configScript.textContent);
  } catch (error) {
    console.error('Failed to parse sparset config:', error);
    return;
  }

  const productsById = {};
  const variantsById = {};

  (config.products || []).forEach((product) => {
    productsById[String(product.id)] = product;

    const variantList = Array.isArray(product.variants) && product.variants.length
      ? product.variants
      : [{
          id: product.variantId,
          title: product.title,
          options: [],
          price: product.price,
          compareAtPrice: product.compareAtPrice,
          available: product.available,
          image: product.image
        }];

    variantList.forEach((variant) => {
      variantsById[String(variant.id)] = {
        id: variant.id,
        productId: product.id,
        productTitle: product.title,
        title: variant.title,
        options: variant.options || [],
        price: variant.price,
        compareAtPrice: variant.compareAtPrice || 0,
        available: variant.available,
        image: variant.image || product.image || '',
        badge: product.badge,
        badgeColor: product.badgeColor,
        hasOnlyDefaultVariant: Boolean(product.hasOnlyDefaultVariant)
      };
    });
  });

  function getVariantEntry(variantId) {
    return variantsById[String(variantId)] || null;
  }

  function getVariantDisplayTitle(variantEntry) {
    if (!variantEntry) return '';
    if (variantEntry.hasOnlyDefaultVariant || !variantEntry.title || variantEntry.title === 'Default Title') {
      return variantEntry.productTitle;
    }
    return `${variantEntry.productTitle} – ${variantEntry.title}`;
  }

  function ensureVariantEntryFromCard(card, variantId) {
    const existing = getVariantEntry(variantId);
    if (existing) return existing;
    if (!card || !variantId) return null;

    const productId = card.getAttribute('data-product-id');
    const product = productsById[String(productId)] || {};
    const entry = {
      id: variantId,
      productId,
      productTitle: product.title || card.querySelector('.product-card__title')?.textContent?.trim() || '',
      title: product.title || '',
      options: [],
      price: parseInt(card.getAttribute('data-base-price') || product.price || '0', 10) || 0,
      compareAtPrice: parseInt(card.getAttribute('data-compare-at-price') || product.compareAtPrice || '0', 10) || 0,
      available: card.getAttribute('data-available') === 'true',
      image: product.image || '',
      badge: product.badge,
      badgeColor: product.badgeColor,
      hasOnlyDefaultVariant: Boolean(product.hasOnlyDefaultVariant)
    };

    variantsById[String(variantId)] = entry;
    return entry;
  }

  const goals = (config.goals || []).slice().sort((a, b) => a.quantity - b.quantity);
  const selectedVariantIds = [];
  const referralInput = root.querySelector('[data-sparset-referral-input]');
  let referralCodeValue = '';
  let resolvedPreviewDiscount = {
    type: null,
    value: 0,
    code: null,
    loaded: false
  };
  let previewDiscountRetried = false;
  const panel = root.querySelector('.bk-media-sparset-builder__panel');
  const countEls = root.querySelectorAll('[data-sparset-count]');
  const goalsFill = root.querySelector('[data-goals-fill]');
  const goalNodes = root.querySelectorAll('.bk-media-sparset-builder__goal-node');
  const slotsContainer = root.querySelector('[data-sparset-slots]');
  const atcButton = root.querySelector('[data-action="add-to-cart"]');
  const savingsRow = root.querySelector('[data-sparset-savings]');
  const savingsAmountEl = root.querySelector('[data-sparset-savings-amount]');
  const totalRow = root.querySelector('[data-sparset-total]');
  const totalPriceEl = root.querySelector('[data-sparset-total-price]');
  const totalCompareEl = root.querySelector('[data-sparset-total-compare]');
  const discountAppliedRow = root.querySelector('[data-sparset-discount-applied]');
  const discountLabelEl = root.querySelector('[data-sparset-discount-label]');
  const discountAmountEl = root.querySelector('[data-sparset-discount-amount]');
  const minProducts = parseInt(root.getAttribute('data-min-products') || config.minProducts || 2, 10);
  const showReferralCode = Boolean(config.showReferralCode);
  const emptySlotMarkup = (() => {
    const existing = root.querySelector('.bk-media-sparset-builder__slot:not([data-free-product-slot])');
    return existing ? existing.innerHTML : '';
  })();
  const minimumSlotCount = slotsContainer
    ? slotsContainer.querySelectorAll('.bk-media-sparset-builder__slot').length
    : 0;

  function hasFreeProductSlot() {
    return Boolean(config.freeProduct?.title);
  }

  function getSlots() {
    if (!slotsContainer) return [];
    return Array.from(slotsContainer.querySelectorAll('.bk-media-sparset-builder__slot'));
  }

  function getSelectedIndexForSlot(slotIndex) {
    return hasFreeProductSlot() ? slotIndex - 1 : slotIndex;
  }

  function createEmptySlot(index) {
    const slot = document.createElement('div');
    slot.className = 'bk-media-sparset-builder__slot';
    slot.setAttribute('data-slot-index', String(index));
    slot.innerHTML = emptySlotMarkup || `
      <div class="bk-media-sparset-builder__slot-icon">
        <svg role="presentation" focusable="false" width="14" height="14" viewBox="0 0 10 10"><path d="M5 1V9M1 5H9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
      </div>
      <div class="bk-media-sparset-builder__slot-content">
        <p class="bk-media-sparset-builder__slot-title" data-slot-title>${config.emptySlotText || 'Choose a product'}</p>
        <p class="bk-media-sparset-builder__slot-subtitle" data-slot-subtitle></p>
      </div>
      <button type="button" class="bk-media-sparset-builder__slot-remove" data-action="remove-slot" hidden aria-label="Remove">
        <svg role="presentation" focusable="false" width="10" height="10" viewBox="0 0 10 10"><path d="M1 1L9 9M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
      </button>
    `;
    return slot;
  }

  function syncSlots() {
    if (!slotsContainer) return;

    const freeOffset = hasFreeProductSlot() ? 1 : 0;
    const neededSelectable = Math.max(minProducts, selectedVariantIds.length + 1);
    const neededTotal = Math.max(minimumSlotCount, freeOffset + neededSelectable);
    let slots = getSlots();

    while (slots.length < neededTotal) {
      slotsContainer.appendChild(createEmptySlot(slots.length));
      slots = getSlots();
    }

    while (slots.length > neededTotal) {
      const lastSlot = slots[slots.length - 1];
      if (!lastSlot || lastSlot.hasAttribute('data-free-product-slot') || lastSlot.classList.contains('is-filled')) {
        break;
      }
      lastSlot.remove();
      slots = getSlots();
    }

    getSlots().forEach((slot, index) => {
      slot.setAttribute('data-slot-index', String(index));
    });
  }

  function renderFreeProductSlot(slot) {
    const freeProduct = config.freeProduct;
    const titleEl = slot.querySelector('[data-slot-title]');
    const subtitleEl = slot.querySelector('[data-slot-subtitle]');
    const iconEl = slot.querySelector('.bk-media-sparset-builder__slot-icon');
    const removeBtn = slot.querySelector('[data-action="remove-slot"]');
    const badgeText = freeProduct.badge || 'GRATIS';

    slot.classList.add('is-filled', 'is-free-product');
    if (titleEl) titleEl.textContent = freeProduct.title;
    if (subtitleEl) {
      subtitleEl.innerHTML = `<span class="badge bk-media-sparset-builder__slot-gratis-badge">${badgeText}</span>`;
    }
    if (iconEl) {
      iconEl.innerHTML = freeProduct.image
        ? `<img src="${freeProduct.image}" alt="${freeProduct.title.replace(/"/g, '&quot;')}" width="48" height="48" loading="lazy">`
        : '';
    }
    if (removeBtn) removeBtn.hidden = true;
  }

  function formatSparsetMoney(cents) {
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents);
    }

    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return `€${amount}`;
  }

  function getCurrentDiscount(count) {
    let current = null;
    goals.forEach((goal) => {
      if (count >= goal.quantity) {
        current = goal;
      }
    });
    return current;
  }

  function getDiscountPercent(count) {
    const currentDiscount = getCurrentDiscount(count);
    return currentDiscount ? currentDiscount.discount : 0;
  }

  function getPreviewDiscountFallbackPercent() {
    return parseInt(config.previewDiscountPercent, 10) || 0;
  }

  function getPreviewDiscountPercent() {
    if (!resolvedPreviewDiscount.loaded) {
      return getPreviewDiscountFallbackPercent();
    }

    if (resolvedPreviewDiscount.type === 'percentage') {
      return resolvedPreviewDiscount.value || 0;
    }

    return getPreviewDiscountFallbackPercent();
  }

  function getPreviewDiscountBadgeText() {
    const previewPercent = getPreviewDiscountPercent();

    if (resolvedPreviewDiscount.code && resolvedPreviewDiscount.type === 'fixed') {
      return `-${formatSparsetMoney(Math.round(resolvedPreviewDiscount.value * 100))}`;
    }

    if (previewPercent > 0) {
      return `-${previewPercent}%`;
    }

    return '';
  }

  function combineDiscountPercents(goalPercent, previewPercent) {
    const goal = parseFloat(goalPercent) || 0;
    const preview = parseFloat(previewPercent) || 0;

    if (goal <= 0 && preview <= 0) return 0;
    if (goal <= 0) return Math.round(preview);
    if (preview <= 0) return Math.round(goal);

    return Math.round(100 - ((100 - goal) * (100 - preview) / 100));
  }

  function getCombinedDiscountPercent(goalPercent) {
    return combineDiscountPercents(goalPercent, getPreviewDiscountPercent());
  }

  function getDisplayDiscountPercent(count) {
    return getCombinedDiscountPercent(getDiscountPercent(count));
  }

  function getTierPercentForNextPlaceholder() {
    const count = selectedVariantIds.length;
    const slots = getSlots();

    for (let slotIndex = 0; slotIndex < slots.length; slotIndex += 1) {
      const slot = slots[slotIndex];
      if (slot.hasAttribute('data-free-product-slot')) continue;

      const selectedIndex = getSelectedIndexForSlot(slotIndex);
      const hasProduct = selectedIndex >= 0 && selectedVariantIds[selectedIndex];

      if (!hasProduct) {
        const productCountAfterFill = Math.max(1, selectedIndex + 1);
        return getDiscountPercent(productCountAfterFill);
      }
    }

    return getDiscountPercent(count + 1);
  }

  function getReferenceUnitPrice(basePriceCents, compareAtCents) {
    const basePrice = parseInt(basePriceCents, 10) || 0;
    const compareAt = parseInt(compareAtCents, 10) || 0;

    if (config.showVariantCompareAt && compareAt > basePrice) {
      return compareAt;
    }

    return basePrice;
  }

  function applyUnitDiscountTruncated(basePriceCents, discountPercent) {
    const basePrice = parseInt(basePriceCents, 10) || 0;
    const discount = parseFloat(discountPercent) || 0;

    if (!discount || discount <= 0 || basePrice <= 0) {
      return basePrice;
    }

    const discountAmount = Math.round(basePrice * discount / 100);
    return basePrice - discountAmount;
  }

  function getDiscountedUnitPriceStacked(basePriceCents, goalPercent, previewPercent) {
    const afterGoal = applyUnitDiscountTruncated(basePriceCents, goalPercent);
    return applyUnitDiscountTruncated(afterGoal, previewPercent);
  }

  function getProductBadgePercent(basePriceCents, compareAtCents, tierGoalPercent) {
    const tierGoal = parseFloat(tierGoalPercent) || 0;
    const previewPercent = getPreviewDiscountPercent();

    if (tierGoal <= 0 && previewPercent <= 0) {
      return 0;
    }

    const referencePrice = getReferenceUnitPrice(basePriceCents, compareAtCents);
    const salePrice = getDiscountedUnitPriceStacked(basePriceCents, tierGoal, previewPercent);

    if (referencePrice <= 0 || salePrice >= referencePrice) {
      return getCombinedDiscountPercent(tierGoal);
    }

    return Math.round((referencePrice - salePrice) / referencePrice * 100);
  }

  async function resolvePreviewDiscountCode() {
    const code = (config.previewDiscountCode || '').trim();
    const fallbackPercent = getPreviewDiscountFallbackPercent();

    if (!code) {
      resolvedPreviewDiscount = {
        type: fallbackPercent > 0 ? 'percentage' : null,
        value: fallbackPercent,
        code: null,
        loaded: true
      };
      return;
    }

    try {
      const cartBefore = await fetch(`${window.Shopify.routes.root}cart.js`).then((response) => response.json());
      const existingApps = cartBefore.cart_level_discount_applications || [];
      const existingCode = existingApps[0]?.title || '';
      const hadDiscount = existingApps.length > 0;
      const alreadyApplied = hadDiscount && existingCode.toLowerCase() === code.toLowerCase();

      if (alreadyApplied) {
        const app = existingApps[0];
        if (app.value_type === 'percentage') {
          resolvedPreviewDiscount = { type: 'percentage', value: parseFloat(app.value), code, loaded: true };
        } else if (app.value_type === 'fixed_amount') {
          resolvedPreviewDiscount = { type: 'fixed', value: parseFloat(app.value) / 100, code, loaded: true };
        } else {
          resolvedPreviewDiscount = { type: fallbackPercent > 0 ? 'percentage' : null, value: fallbackPercent, code: null, loaded: true };
        }
        return;
      }

      const cartAfter = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: code })
      }).then((response) => response.json());

      const codeEntry = (cartAfter.discount_codes || []).find((entry) =>
        String(entry.code || '').toLowerCase() === code.toLowerCase()
      );

      const needsRestore = !hadDiscount || existingCode.toLowerCase() !== code.toLowerCase();

      if (!codeEntry?.applicable) {
        if (needsRestore) {
          await fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: hadDiscount ? existingCode : '' })
          });
        }

        resolvedPreviewDiscount = {
          type: fallbackPercent > 0 ? 'percentage' : null,
          value: fallbackPercent,
          code: null,
          loaded: true
        };
        return;
      }

      const app = (cartAfter.cart_level_discount_applications || []).find((entry) =>
        String(entry.title || '').toLowerCase() === code.toLowerCase()
      ) || cartAfter.cart_level_discount_applications?.[0];

      if (app?.value_type === 'percentage') {
        resolvedPreviewDiscount = { type: 'percentage', value: parseFloat(app.value), code, loaded: true };
      } else if (app?.value_type === 'fixed_amount') {
        resolvedPreviewDiscount = { type: 'fixed', value: parseFloat(app.value) / 100, code, loaded: true };
      } else {
        resolvedPreviewDiscount = {
          type: fallbackPercent > 0 ? 'percentage' : null,
          value: fallbackPercent,
          code: null,
          loaded: true
        };
      }

      if (needsRestore) {
        const restoredCart = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: hadDiscount ? existingCode : '' })
        }).then((response) => response.json());

        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'sparset:discount-preview',
            cart: restoredCart
          }
        }));
      }
    } catch (error) {
      console.error('Failed to resolve preview discount code:', error);
      resolvedPreviewDiscount = {
        type: fallbackPercent > 0 ? 'percentage' : null,
        value: fallbackPercent,
        code: null,
        loaded: true
      };
    }
  }

  function maybeRetryPreviewDiscount(count) {
    const code = (config.previewDiscountCode || '').trim();
    if (!code || previewDiscountRetried || count < minProducts) return;
    if (resolvedPreviewDiscount.code) return;

    previewDiscountRetried = true;
    resolvePreviewDiscountCode().then(() => updateUI());
  }

  function getPreviewDiscountSavings(count) {
    if (!count || selectedVariantIds.length === 0) return 0;

    const goalPercent = getDiscountPercent(count);
    let afterGoalTotal = 0;
    let afterPreviewTotal = 0;

    selectedVariantIds.forEach((variantId) => {
      const product = getVariantEntry(variantId);
      if (!product) return;

      const afterGoal = getDiscountedUnitPriceStacked(product.price, goalPercent, 0);
      const afterPreview = getDiscountedUnitPriceStacked(product.price, goalPercent, getPreviewDiscountPercent());
      afterGoalTotal += afterGoal;
      afterPreviewTotal += afterPreview;
    });

    if (!afterGoalTotal) return 0;

    if (resolvedPreviewDiscount.type === 'fixed' && resolvedPreviewDiscount.value > 0) {
      return Math.min(afterGoalTotal, Math.round(resolvedPreviewDiscount.value * 100));
    }

    const previewPercent = getPreviewDiscountPercent();
    if (previewPercent > 0) {
      return afterGoalTotal - afterPreviewTotal;
    }

    return 0;
  }

  function getPreviewDiscountLabel() {
    if (resolvedPreviewDiscount.code) {
      return resolvedPreviewDiscount.code;
    }

    const previewPercent = getPreviewDiscountPercent();
    if (previewPercent > 0) {
      return `-${previewPercent}%`;
    }

    return '';
  }

  function hasActivePreviewDiscount() {
    if (!resolvedPreviewDiscount.loaded) return false;
    if (resolvedPreviewDiscount.code) return true;
    return getPreviewDiscountPercent() > 0;
  }

  function updatePreviewDiscountRow(count, totals) {
    if (!discountAppliedRow || !discountLabelEl || !discountAmountEl) return;

    if (!hasActivePreviewDiscount()) {
      discountAppliedRow.hidden = true;
      return;
    }

    const label = getPreviewDiscountLabel();
    if (!label) {
      discountAppliedRow.hidden = true;
      return;
    }

    discountAppliedRow.hidden = false;
    discountLabelEl.textContent = label;

    if (count > 0 && totals.originalTotal > 0) {
      const savings = getPreviewDiscountSavings(count);
      if (savings > 0) {
        discountAmountEl.textContent = `-${formatSparsetMoney(savings)}`;
        discountAmountEl.hidden = false;
        return;
      }
    }

    discountAmountEl.textContent = '';
    discountAmountEl.hidden = true;
  }

  function renderPriceMarkup(basePriceCents, goalPercent, compareAtCents, includePreview) {
    const basePrice = parseInt(basePriceCents, 10) || 0;
    const compareAt = parseInt(compareAtCents, 10) || 0;
    const showCompareAt = config.showVariantCompareAt && compareAt > basePrice;
    const previewPercent = includePreview === false ? 0 : getPreviewDiscountPercent();
    const salePrice = getDiscountedUnitPriceStacked(basePrice, goalPercent, previewPercent);
    const referencePrice = getReferenceUnitPrice(basePrice, compareAt);

    if (showCompareAt) {
      if (salePrice >= referencePrice) {
        return `<sale-price>${formatSparsetMoney(basePrice)}</sale-price>`;
      }

      return `<sale-price class="text-on-sale">${formatSparsetMoney(salePrice)}</sale-price><compare-at-price class="text-subdued line-through">${formatSparsetMoney(referencePrice)}</compare-at-price>`;
    }

    if ((!goalPercent && !previewPercent) || salePrice >= basePrice) {
      return `<sale-price>${formatSparsetMoney(basePrice)}</sale-price>`;
    }

    return `<sale-price class="text-on-sale">${formatSparsetMoney(salePrice)}</sale-price><compare-at-price class="text-subdued line-through">${formatSparsetMoney(basePrice)}</compare-at-price>`;
  }

  function getSelectionTotals(count) {
    const goalPercent = getDiscountPercent(count);
    let priceSubtotal = 0;
    let compareSubtotal = 0;

    selectedVariantIds.forEach((variantId) => {
      const product = getVariantEntry(variantId);
      if (!product) return;

      priceSubtotal += product.price;
      compareSubtotal += getReferenceUnitPrice(product.price, product.compareAtPrice);
    });

    const discountAmount = goalPercent > 0 ? Math.round(priceSubtotal * goalPercent / 100) : 0;
    const discountedTotal = priceSubtotal - discountAmount;
    const originalTotal = priceSubtotal;
    const savings = (config.showVariantCompareAt && compareSubtotal > priceSubtotal)
      ? compareSubtotal - discountedTotal
      : priceSubtotal - discountedTotal;

    return {
      priceSubtotal,
      compareSubtotal,
      originalTotal,
      discountedTotal,
      savings
    };
  }

  function getGoalSubtitleForSlot(slotIndex) {
    const goalIndex = hasFreeProductSlot() ? Math.max(0, slotIndex - 1) : slotIndex;
    if (goalIndex < goals.length) {
      return goals[goalIndex].subtitle || '';
    }
    return '';
  }

  function getProductCount(productId) {
    return selectedVariantIds.filter((variantId) => {
      const product = getVariantEntry(variantId);
      return product && String(product.productId) === String(productId);
    }).length;
  }

  function getSelectedVariantIdsForProduct(productId) {
    return selectedVariantIds.filter((variantId) => {
      const product = getVariantEntry(variantId);
      return product && String(product.productId) === String(productId);
    });
  }

  function setProductQuantity(variantId, productId, quantity) {
    const remaining = selectedVariantIds.filter((id) => {
      const product = getVariantEntry(id);
      return !product || String(product.productId) !== String(productId);
    });

    const clampedQty = Math.max(0, quantity);

    selectedVariantIds.length = 0;
    selectedVariantIds.push(...remaining);

    for (let i = 0; i < clampedQty; i += 1) {
      selectedVariantIds.push(String(variantId));
    }

    updateUI();
  }

  function bindQuantitySelector(card) {
    const selector = card.querySelector('quantity-selector');
    if (!selector || selector.dataset.sparsetBound === 'true') return;

    const productId = String(card.getAttribute('data-product-id'));
    const input = card.querySelector('[data-sparset-quantity-input]');
    const minusBtn = selector.querySelector('button:first-of-type');
    const plusBtn = selector.querySelector('button:last-of-type');

    const applyQuantity = (quantity) => {
      const variantId = card.getAttribute('data-variant-id');
      setProductQuantity(variantId, productId, quantity);
    };

    const onMinus = (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      applyQuantity(getProductCount(productId) - 1);
    };

    const onPlus = (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      applyQuantity(getProductCount(productId) + 1);
    };

    const onInputChange = () => {
      applyQuantity(parseInt(input.value, 10) || 0);
    };

    minusBtn?.addEventListener('click', onMinus, true);
    plusBtn?.addEventListener('click', onPlus, true);
    input?.addEventListener('change', onInputChange);

    selector.dataset.sparsetBound = 'true';
  }

  function equalizeCardUspHeights() {
    const grid = root.querySelector('.bk-media-sparset-builder__grid');
    if (!grid) return;

    const cards = Array.from(grid.querySelectorAll('.bk-media-sparset-builder__card'));
    const footerGroups = cards.map((card) => {
      const footerEl = card.querySelector('.bk-media-sparset-builder__card-footer');
      if (!footerEl) return null;
      footerEl.style.minHeight = '';
      return { card, footerEl };
    }).filter(Boolean);

    if (!footerGroups.length) return;

    const rows = new Map();

    footerGroups.forEach(({ card, footerEl }) => {
      const top = Math.round(card.getBoundingClientRect().top);
      let rowKey = null;

      for (const key of rows.keys()) {
        if (Math.abs(key - top) <= 4) {
          rowKey = key;
          break;
        }
      }

      if (rowKey === null) rowKey = top;
      if (!rows.has(rowKey)) rows.set(rowKey, []);
      rows.get(rowKey).push(footerEl);
    });

    rows.forEach((elements) => {
      const maxHeight = Math.max(...elements.map((el) => el.getBoundingClientRect().height));
      elements.forEach((el) => {
        el.style.minHeight = `${Math.ceil(maxHeight)}px`;
      });
    });
  }

  function updateProductCards() {
    const cardTierPercent = getTierPercentForNextPlaceholder();

    root.querySelectorAll('.bk-media-sparset-builder__card').forEach((card) => {
      const productId = String(card.getAttribute('data-product-id'));
      const hasVariants = card.getAttribute('data-has-variants') === 'true';
      const addButton = card.querySelector('[data-action="add-product"]');
      const quantityWrap = card.querySelector('[data-sparset-quantity-wrap]');
      const quantityInput = card.querySelector('[data-sparset-quantity-input]');
      const priceEl = card.querySelector('[data-card-price]');
      const discountBadgeWrap = card.querySelector('[data-card-discount-badge-wrap]');
      const discountBadge = card.querySelector('[data-card-discount-badge]');
      const productCount = getProductCount(productId);
      const selectedForProduct = getSelectedVariantIdsForProduct(productId);
      const uniqueVariantIds = [...new Set(selectedForProduct)];
      const activeVariantId = uniqueVariantIds.length === 1
        ? uniqueVariantIds[0]
        : (card.getAttribute('data-variant-id') || productsById[productId]?.variantId);
      const activeVariant = getVariantEntry(activeVariantId);
      const basePrice = parseInt(
        activeVariant?.price
          || card.getAttribute('data-base-price')
          || priceEl?.getAttribute('data-base-price')
          || '0',
        10
      );
      const compareAtPrice = parseInt(
        activeVariant?.compareAtPrice
          || card.getAttribute('data-compare-at-price')
          || '0',
        10
      );
      const badgePercent = getProductBadgePercent(basePrice, compareAtPrice, cardTierPercent);
      const isAvailable = card.getAttribute('data-available') === 'true';

      if (activeVariantId) {
        card.setAttribute('data-variant-id', String(activeVariantId));
        card.setAttribute('data-base-price', String(basePrice));
        card.setAttribute('data-compare-at-price', String(compareAtPrice));
      }

      card.classList.toggle('is-selected', productCount > 0);
      card.classList.toggle('is-addable', isAvailable);

      if (priceEl && basePrice > 0) {
        priceEl.innerHTML = renderPriceMarkup(basePrice, cardTierPercent, compareAtPrice);
      }

      if (discountBadgeWrap && discountBadge) {
        if (badgePercent > 0) {
          discountBadge.textContent = `-${badgePercent}%`;
          discountBadgeWrap.hidden = false;
        } else {
          discountBadge.textContent = '';
          discountBadgeWrap.hidden = true;
        }
      }

      const useQuantitySelector = productCount > 0 && !hasVariants;

      if (useQuantitySelector) {
        if (addButton) addButton.hidden = true;
        if (quantityWrap) quantityWrap.hidden = false;
        if (quantityInput) {
          quantityInput.value = String(productCount);
          quantityInput.size = Math.max(String(productCount).length + 1, 2);
        }
        bindQuantitySelector(card);
      } else {
        if (addButton) {
          addButton.hidden = false;
          addButton.disabled = !isAvailable;
        }
        if (quantityWrap) quantityWrap.hidden = true;
      }
    });

    requestAnimationFrame(equalizeCardUspHeights);
  }

  function adjustGoalNodePositions() {
    const track = root.querySelector('.bk-media-sparset-builder__goals-track');
    if (!track || !goalNodes.length) return;

    const inset = 8;
    const minBound = inset;
    const maxBound = 100 - inset;
    const trackWidth = track.offsetWidth || 1;

    const items = Array.from(goalNodes).map((node) => ({
      node,
      ideal: parseFloat(node.getAttribute('data-goal-ideal-position') || node.getAttribute('data-goal-position') || '0'),
      quantity: parseInt(node.getAttribute('data-goal-quantity'), 10)
    })).sort((a, b) => a.ideal - b.ideal);

    const count = items.length;
    if (!count) return;

    let maxNodeWidth = 44;
    items.forEach((item) => {
      maxNodeWidth = Math.max(maxNodeWidth, item.node.offsetWidth || 0);
    });

    const minGapPercent = Math.min(16, Math.max(7, (maxNodeWidth / trackWidth) * 100 * 0.95));
    let positions = [];

    if (count === 1) {
      positions = [Math.max(minBound, Math.min(maxBound, items[0].ideal))];
    } else {
      const ideals = items.map((item) => item.ideal);
      const available = maxBound - minBound;
      const required = (count - 1) * minGapPercent;
      const extra = available - required;

      if (extra <= 0) {
        for (let i = 0; i < count; i += 1) {
          positions[i] = minBound + (i / (count - 1)) * available;
        }
      } else {
        const idealGaps = [];
        let totalIdealGap = 0;

        for (let i = 0; i < count - 1; i += 1) {
          const gap = Math.max(0, ideals[i + 1] - ideals[i]);
          idealGaps.push(gap);
          totalIdealGap += gap;
        }

        positions[0] = minBound;
        for (let i = 0; i < count - 1; i += 1) {
          const extraGap = totalIdealGap > 0 ? (idealGaps[i] / totalIdealGap) * extra : extra / (count - 1);
          positions[i + 1] = positions[i] + minGapPercent + extraGap;
        }
      }
    }

    items.forEach((item, index) => {
      const position = Math.round(positions[index] * 10) / 10;
      item.node.style.setProperty('--goal-position', `${position}%`);
      item.node.setAttribute('data-goal-position', String(position));
    });
  }

  function getGoalNodesData() {
    return Array.from(goalNodes).map((node) => ({
      quantity: parseInt(node.getAttribute('data-goal-quantity'), 10),
      position: parseFloat(node.getAttribute('data-goal-position') || node.style.getPropertyValue('--goal-position') || '0')
    })).sort((a, b) => a.quantity - b.quantity);
  }

  function getProgressPercent(count) {
    const nodes = getGoalNodesData();

    if (!nodes.length) {
      return count > 0 ? Math.min((count / Math.max(minProducts, 1)) * 100, 100) : 0;
    }

    if (count <= 0) return 0;

    const lastNode = nodes[nodes.length - 1];
    if (count >= lastNode.quantity) {
      return lastNode.position;
    }

    let prev = { quantity: 0, position: 0 };

    for (let i = 0; i < nodes.length; i += 1) {
      const node = nodes[i];

      if (count === node.quantity) {
        return node.position;
      }

      if (count < node.quantity) {
        const range = node.quantity - prev.quantity;
        const ratio = range > 0 ? (count - prev.quantity) / range : 0;
        return prev.position + ratio * (node.position - prev.position);
      }

      prev = node;
    }

    return lastNode.position;
  }

  function updateUI() {
    const count = selectedVariantIds.length;
    const progress = getProgressPercent(count);
    const goalPercent = getDiscountPercent(count);
    const totals = getSelectionTotals(count);

    syncSlots();

    countEls.forEach((el) => {
      el.textContent = String(count);
    });

    if (goalsFill) {
      goalsFill.style.width = `${progress}%`;
    }

    goalNodes.forEach((node) => {
      const quantity = parseInt(node.getAttribute('data-goal-quantity'), 10);
      const goalDiscount = parseInt(node.getAttribute('data-goal-discount'), 10);
      const discountEl = node.querySelector('.bk-media-sparset-builder__goal-discount');

      node.classList.toggle('is-reached', count >= quantity);

      if (discountEl && !Number.isNaN(goalDiscount)) {
        discountEl.textContent = `${getCombinedDiscountPercent(goalDiscount)}%`;
      }
    });

    getSlots().forEach((slot, index) => {
      if (slot.hasAttribute('data-free-product-slot')) {
        renderFreeProductSlot(slot);
        return;
      }

      const titleEl = slot.querySelector('[data-slot-title]');
      const subtitleEl = slot.querySelector('[data-slot-subtitle]');
      const iconEl = slot.querySelector('.bk-media-sparset-builder__slot-icon');
      const removeBtn = slot.querySelector('[data-action="remove-slot"]');
      const selectedIndex = getSelectedIndexForSlot(index);
      const variantId = selectedIndex >= 0 ? selectedVariantIds[selectedIndex] : null;
      const product = variantId ? getVariantEntry(variantId) : null;

      slot.classList.remove('is-free-product');

      if (product) {
        const displayTitle = getVariantDisplayTitle(product);
        slot.classList.add('is-filled');
        if (titleEl) titleEl.textContent = displayTitle;
        if (subtitleEl) {
          subtitleEl.innerHTML = renderPriceMarkup(product.price, goalPercent, product.compareAtPrice, false);
        }
        if (iconEl) {
          iconEl.innerHTML = product.image
            ? `<img src="${product.image}" alt="${displayTitle.replace(/"/g, '&quot;')}" width="48" height="48" loading="lazy">`
            : '';
        }
        if (removeBtn) removeBtn.hidden = false;
      } else {
        slot.classList.remove('is-filled');
        if (titleEl) titleEl.textContent = config.emptySlotText || 'Choose a product';
        if (subtitleEl) {
          const subtitle = getGoalSubtitleForSlot(index);
          subtitleEl.textContent = subtitle;
        }
        if (iconEl) {
          iconEl.innerHTML = '<svg role="presentation" focusable="false" width="14" height="14" viewBox="0 0 10 10"><path d="M5 1V9M1 5H9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
        }
        if (removeBtn) removeBtn.hidden = true;
      }
    });

    if (savingsRow && savingsAmountEl) {
      const showSavings = count > 0 && totals.savings > 0;
      savingsRow.hidden = !showSavings;
      if (showSavings) {
        savingsAmountEl.textContent = `-${formatSparsetMoney(totals.savings)}`;
      }
    }

    updatePreviewDiscountRow(count, totals);

    if (totalRow && totalPriceEl) {
      const showTotal = count > 0;
      totalRow.hidden = !showTotal;

      if (showTotal) {
        totalPriceEl.textContent = formatSparsetMoney(totals.discountedTotal);

        if (totalCompareEl) {
          if (goalPercent > 0 && totals.discountedTotal < totals.originalTotal) {
            totalCompareEl.textContent = formatSparsetMoney(totals.originalTotal);
            totalCompareEl.hidden = false;
          } else {
            totalCompareEl.textContent = '';
            totalCompareEl.hidden = true;
          }
        }
      }
    }

    if (atcButton) {
      atcButton.disabled = count < minProducts;
    }

    updateProductCards();
    maybeRetryPreviewDiscount(count);
  }

  function addProduct(variantId, options = {}) {
    if (!variantId) return false;

    let entry = getVariantEntry(variantId);
    if (!entry && options.card) {
      entry = ensureVariantEntryFromCard(options.card, variantId);
    }
    if (!entry) return false;

    selectedVariantIds.push(String(variantId));

    if (options.card) {
      options.card.setAttribute('data-variant-id', String(variantId));
      options.card.setAttribute('data-base-price', String(entry.price || 0));
      options.card.setAttribute('data-compare-at-price', String(entry.compareAtPrice || 0));
    }

    updateUI();
    return true;
  }

  function removeProductAt(index) {
    if (index < 0 || index >= selectedVariantIds.length) return;
    selectedVariantIds.splice(index, 1);
    updateUI();
  }

  const variantDrawer = root.querySelector('.bk-media-sparset-builder__variant-drawer')
    || document.getElementById(`sparset-variant-drawer-${root.getAttribute('data-section-id')}`);
  const variantOptionsEl = variantDrawer?.querySelector('[data-sparset-variant-options]');
  const variantTitleEl = variantDrawer?.querySelector('[data-sparset-variant-title]');
  const variantPriceEl = variantDrawer?.querySelector('[data-sparset-variant-price]');
  const variantMediaEl = variantDrawer?.querySelector('[data-sparset-variant-media]');
  const variantConfirmBtn = variantDrawer?.querySelector('[data-action="confirm-variant"]');
  let activeVariantCard = null;
  let activeVariantProductId = null;
  let selectedOptionValues = [];

  function findMatchingVariant(product, optionValues) {
    const variants = Array.isArray(product?.variants) ? product.variants : [];
    return variants.find((variant) => {
      const options = variant.options || [];
      if (options.length !== optionValues.length) return false;
      return options.every((value, index) => String(value) === String(optionValues[index]));
    }) || null;
  }

  function getAvailableValuesForOption(product, optionIndex, currentSelections) {
    const option = (product.options || [])[optionIndex];
    if (!option) return [];

    return (option.values || []).filter((value) => {
      const trial = currentSelections.slice();
      trial[optionIndex] = value;
      return (product.variants || []).some((variant) => {
        if (!variant.available) return false;
        return trial.every((selectedValue, index) => {
          if (!selectedValue) return true;
          return String(variant.options?.[index]) === String(selectedValue);
        });
      });
    });
  }

  function syncVariantPickerSelection() {
    if (!activeVariantProductId || !variantDrawer) return;

    const product = productsById[String(activeVariantProductId)];
    if (!product) return;

    const matchedVariant = findMatchingVariant(product, selectedOptionValues);
    const priceCents = matchedVariant?.price ?? product.price;
    const compareAtCents = matchedVariant?.compareAtPrice ?? product.compareAtPrice;
    const image = matchedVariant?.image || product.image || '';
    const available = Boolean(matchedVariant?.available);

    if (variantTitleEl) variantTitleEl.textContent = product.title || '';
    if (variantPriceEl) {
      variantPriceEl.innerHTML = renderPriceMarkup(priceCents, getTierPercentForNextPlaceholder(), compareAtCents, true);
    }
    if (variantMediaEl) {
      variantMediaEl.innerHTML = image
        ? `<img src="${image}" alt="${(product.title || '').replace(/"/g, '&quot;')}" width="80" height="80" loading="lazy" class="rounded-xs">`
        : '';
    }

    if (variantOptionsEl) {
      variantOptionsEl.querySelectorAll('[data-option-index]').forEach((fieldset) => {
        const optionIndex = parseInt(fieldset.getAttribute('data-option-index'), 10);
        const availableValues = getAvailableValuesForOption(product, optionIndex, selectedOptionValues);

        fieldset.querySelectorAll('[data-option-value]').forEach((button) => {
          const value = button.getAttribute('data-option-value');
          const isSelected = String(selectedOptionValues[optionIndex]) === String(value);
          const isAvailable = availableValues.includes(value);
          button.classList.toggle('is-selected', isSelected);
          button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          button.disabled = !isAvailable;
          button.classList.toggle('is-disabled', !isAvailable);
        });
      });
    }

    if (variantConfirmBtn) {
      variantConfirmBtn.disabled = !matchedVariant || !available;
      variantConfirmBtn.dataset.variantId = matchedVariant ? String(matchedVariant.id) : '';
    }
  }

  function openSparsetVariantPicker(card) {
    const productId = card.getAttribute('data-product-id');
    const product = productsById[String(productId)];
    if (!product || !variantDrawer || typeof variantDrawer.show !== 'function') {
      addProduct(card.getAttribute('data-variant-id'), { card });
      return;
    }

    const variants = Array.isArray(product.variants) ? product.variants : [];
    const options = Array.isArray(product.options) ? product.options : [];
    if (!variants.length || product.hasOnlyDefaultVariant || variants.length === 1 || !options.length) {
      addProduct(String(variants[0]?.id || product.variantId || card.getAttribute('data-variant-id')), { card });
      return;
    }

    activeVariantCard = card;
    activeVariantProductId = productId;

    const defaultVariant = variants.find((variant) => String(variant.id) === String(product.variantId))
      || variants.find((variant) => variant.available)
      || variants[0];
    selectedOptionValues = [...(defaultVariant?.options || [])];

    if (variantOptionsEl) {
      variantOptionsEl.innerHTML = (product.options || []).map((option, optionIndex) => {
        const valuesMarkup = (option.values || []).map((value) => (
          `<button type="button" class="block-swatch" data-option-value="${String(value).replace(/"/g, '&quot;')}" aria-pressed="false">${String(value).replace(/</g, '&lt;')}</button>`
        )).join('');

        return `
          <fieldset class="variant-picker__option" data-option-index="${optionIndex}">
            <div class="variant-picker__option-info">
              <legend>${String(option.name || '').replace(/</g, '&lt;')}:</legend>
            </div>
            <div class="variant-picker__option-values wrap gap-2">
              ${valuesMarkup}
            </div>
          </fieldset>
        `;
      }).join('');
    }

    syncVariantPickerSelection();
    variantDrawer.show();
  }

  function handleCardAdd(card) {
    if (!card || card.getAttribute('data-available') !== 'true') return;

    if (card.getAttribute('data-has-variants') === 'true') {
      openSparsetVariantPicker(card);
      return;
    }

    addProduct(card.getAttribute('data-variant-id'), { card });
  }

  if (showReferralCode) {
    referralInput?.addEventListener('input', function () {
      referralCodeValue = referralInput.value.trim();
    });
  }

  if (variantDrawer) {
    variantDrawer.addEventListener('click', function (event) {
      const optionButton = event.target.closest('[data-option-value]');
      if (optionButton && variantDrawer.contains(optionButton)) {
        const fieldset = optionButton.closest('[data-option-index]');
        const optionIndex = parseInt(fieldset?.getAttribute('data-option-index'), 10);
        if (Number.isNaN(optionIndex) || optionButton.disabled) return;
        selectedOptionValues[optionIndex] = optionButton.getAttribute('data-option-value');
        syncVariantPickerSelection();
        return;
      }

      const confirmVariantBtn = event.target.closest('[data-action="confirm-variant"]');
      if (confirmVariantBtn && variantDrawer.contains(confirmVariantBtn)) {
        if (confirmVariantBtn.disabled) return;
        const variantId = confirmVariantBtn.dataset.variantId;
        if (!variantId) return;
        addProduct(variantId, { card: activeVariantCard });
        if (typeof variantDrawer.hide === 'function') variantDrawer.hide();
        activeVariantCard = null;
        activeVariantProductId = null;
      }
    });
  }

  root.addEventListener('click', function (event) {
    const addProductBtn = event.target.closest('[data-action="add-product"]');
    if (addProductBtn) {
      const card = addProductBtn.closest('.bk-media-sparset-builder__card');
      if (!card || addProductBtn.disabled) return;
      handleCardAdd(card);
      return;
    }

    const card = event.target.closest('.bk-media-sparset-builder__card');
    if (card && !event.target.closest('quantity-selector')) {
      handleCardAdd(card);
      return;
    }

    const removeSlotBtn = event.target.closest('[data-action="remove-slot"]');
    if (removeSlotBtn) {
      const slot = removeSlotBtn.closest('.bk-media-sparset-builder__slot');
      if (!slot || slot.hasAttribute('data-free-product-slot')) return;
      const slotIndex = parseInt(slot.getAttribute('data-slot-index'), 10);
      const selectedIndex = getSelectedIndexForSlot(slotIndex);
      if (selectedIndex < 0) return;
      removeProductAt(selectedIndex);
      return;
    }

    const toggleBtn = event.target.closest('[data-action="toggle-panel"]');
    if (toggleBtn && panel) {
      const expanded = panel.getAttribute('data-expanded') === 'true';
      panel.setAttribute('data-expanded', expanded ? 'false' : 'true');
      toggleBtn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      return;
    }

    const atcBtn = event.target.closest('[data-action="add-to-cart"]');
    if (atcBtn) {
      handleAddToCart(atcBtn);
    }
  });

  function getReferralCodeFromUrl() {
    const param = (config.referralUrlParam || 'ref').trim();
    if (!param) return '';

    try {
      const value = new URLSearchParams(window.location.search).get(param);
      return value ? value.trim() : '';
    } catch (error) {
      return '';
    }
  }

  function getActiveReferralCode() {
    if (!showReferralCode) return '';

    const fromInput = referralInput?.value?.trim();
    if (fromInput) return fromInput;
    if (referralCodeValue) return referralCodeValue;
    return (config.defaultReferralCode || '').trim();
  }

  function initReferralCode() {
    if (!showReferralCode) return;

    referralCodeValue = getReferralCodeFromUrl() || (config.defaultReferralCode || '').trim();

    if (referralInput && referralCodeValue) {
      referralInput.value = referralCodeValue;
    }
  }

  async function updateCartTrackingAttributes(referralCode, discountPercent, bundleMeta = null) {
    const cartBefore = await fetch(`${window.Shopify.routes.root}cart.js`).then((response) => response.json());
    const attributes = {};

    if (cartBefore.attributes) {
      Object.keys(cartBefore.attributes).forEach((key) => {
        const value = cartBefore.attributes[key];
        if (value != null && String(value).trim() !== '') {
          attributes[key] = String(value);
        }
      });
    }

    if (showReferralCode) {
      if (referralCode) {
        attributes.referral_code = referralCode;
      } else {
        delete attributes.referral_code;
      }
    }

    if (discountPercent > 0) {
      attributes.bundle_discount_percent = String(discountPercent);
    } else {
      delete attributes.bundle_discount_percent;
    }

    if (bundleMeta?.bundleId && bundleMeta.bundleComponents) {
      attributes[`bundle_components_${bundleMeta.bundleId}`] = bundleMeta.bundleComponents;
    }

    if (bundleMeta?.bundleId && bundleMeta.totals) {
      attributes[`bundle_compare_total_${bundleMeta.bundleId}`] = String(bundleMeta.totals.priceSubtotal || 0);
      attributes[`bundle_sale_total_${bundleMeta.bundleId}`] = String(bundleMeta.totals.discountedTotal || 0);
      attributes[`bundle_compare_at_total_${bundleMeta.bundleId}`] = String(bundleMeta.totals.compareSubtotal || 0);
      attributes[`bundle_discount_percent_${bundleMeta.bundleId}`] = String(bundleMeta.discountPercent || 0);
      attributes[`bundle_show_compare_at_${bundleMeta.bundleId}`] = config.showVariantCompareAt ? 'true' : 'false';
    }

    const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes })
    });

    if (!response.ok) {
      throw new Error('Failed to update cart tracking attributes');
    }

    return response.json();
  }

  function generateBundleId(group) {
    const bundleGroup = group || 'starter';
    let instanceId;

    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      instanceId = crypto.randomUUID().replace(/-/g, '');
    } else {
      instanceId = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
    }

    return `${bundleGroup}-${instanceId}`;
  }

  function buildBundleComponentsProperty(itemQuantities) {
    return Object.keys(itemQuantities).map((id) => {
      const qty = itemQuantities[id];
      const product = getVariantEntry(id);
      const title = encodeURIComponent(getVariantDisplayTitle(product) || product?.productTitle || '');
      const image = product?.image ? encodeURIComponent(product.image) : '';
      return image ? `${id}::${qty}::${title}::${image}` : `${id}::${qty}::${title}`;
    }).join('||');
  }

  function bundleLineProperties(bundleId, parentVariantId, bundleTitle, bundleTotals, bundleComponents, tracking = {}) {
    const props = {
      _BundleId: bundleId,
      _BundleIsParent: 'true',
      _BundleRole: 'parent'
    };

    if (parentVariantId) {
      props._BundleParentVariantId = String(parentVariantId);
    }

    if (bundleTitle) {
      props._BundleTitle = bundleTitle;
    }

    if (bundleTotals?.priceSubtotal > 0) {
      props._BundleCompareTotal = String(bundleTotals.priceSubtotal);
    }

    if (bundleTotals?.compareSubtotal > 0) {
      props._BundleCompareAtTotal = String(bundleTotals.compareSubtotal);
    }

    if (bundleTotals?.discountedTotal > 0) {
      props._BundleDiscountedTotal = String(bundleTotals.discountedTotal);
    }

    props._BundleShowVariantCompareAt = config.showVariantCompareAt ? 'true' : 'false';

    props._BundlePricing = [
      bundleTotals?.priceSubtotal || 0,
      bundleTotals?.discountedTotal || 0,
      tracking.discountPercent || 0,
      bundleTotals?.compareSubtotal || 0
    ].join('|');

    if (bundleComponents) {
      props._BundleComponents = bundleComponents;
    }

    if (tracking.referralCode) {
      props._BundleReferralCode = tracking.referralCode;
    }

    if (tracking.discountPercent > 0) {
      props._BundleDiscountPercent = String(tracking.discountPercent);
    }

    return props;
  }

  async function handleAddToCart(button) {
    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;
    if (selectedVariantIds.length < minProducts) return;

    const parentVariantId = config.parentVariantId ? parseInt(config.parentVariantId, 10) : null;
    if (!parentVariantId) {
      alert('Bundle parent product is missing. Add this section to a product page or set a parent product.');
      return;
    }

    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    try {
      const bundleId = generateBundleId(config.bundleGroup || 'starter');
      const bundleTotals = getSelectionTotals(selectedVariantIds.length);
      const discountPercent = getDiscountPercent(selectedVariantIds.length);
      const referralCode = getActiveReferralCode();

      const itemQuantities = {};
      selectedVariantIds.forEach((variantId) => {
        const id = parseInt(variantId, 10);
        itemQuantities[id] = (itemQuantities[id] || 0) + 1;
      });

      const bundleComponents = buildBundleComponentsProperty(itemQuantities);

      const parentLineProps = bundleLineProperties(
        bundleId,
        parentVariantId,
        (config.bundleTitle || '').trim(),
        bundleTotals,
        bundleComponents,
        { referralCode, discountPercent }
      );
      const childLineProps = {
        _BundleId: bundleId,
        _BundleRole: 'child'
      };

      const items = [
        { id: parentVariantId, quantity: 1, properties: parentLineProps }
      ];

      Object.keys(itemQuantities).forEach((id) => {
        const variantId = parseInt(id, 10);
        if (variantId === parentVariantId) return;

        items.push({
          id: variantId,
          quantity: itemQuantities[id],
          properties: childLineProps
        });
      });

      const nativeCartDrawer = document.querySelector('cart-drawer');
      const requestBody = { items };

      if (nativeCartDrawer) {
        const sectionsToBundle = ['variant-added'];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        }));

        const sectionId = getCartDrawerSectionId(nativeCartDrawer);
        if (sectionId && !sectionsToBundle.includes(sectionId)) {
          sectionsToBundle.push(sectionId);
        }
        requestBody.sections = sectionsToBundle.join(',');
      }

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || 'Failed to add items to cart');
      }

      const responseJson = await response.json();

      await updateCartTrackingAttributes(referralCode, discountPercent, {
        bundleId,
        bundleComponents,
        totals: {
          priceSubtotal: bundleTotals.priceSubtotal,
          discountedTotal: bundleTotals.discountedTotal,
          compareSubtotal: bundleTotals.compareSubtotal,
          discountPercent
        }
      });

      let cartContent = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();

      if (nativeCartDrawer) {
        cartContent = await attachCartDrawerSections(cartContent, nativeCartDrawer);
      } else if (responseJson.sections) {
        if (!cartContent.sections) cartContent.sections = {};
        Object.assign(cartContent.sections, responseJson.sections);
      }

      const productForm = document.querySelector('form[is="product-form"]');
      const formToUse = productForm || document.createElement('form');
      let formAdded = false;

      if (!productForm) {
        document.body.appendChild(formToUse);
        formAdded = true;
      }

      formToUse.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true,
        cancelable: true,
        detail: {
          items: responseJson.items || [responseJson],
          cart: cartContent
        }
      }));

      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          cart: cartContent
        }
      }));

      if (formAdded) {
        document.body.removeChild(formToUse);
      }

      const shouldUseNativeCartDrawer = nativeCartDrawer
        && window.themeVariables?.settings?.cartType === 'drawer';

      if (!shouldUseNativeCartDrawer) {
        if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
          window.Rebuy.SmartCart.show();
        } else {
          window.dispatchEvent(new CustomEvent('rebuy:cart.open'));
        }
      }
    } catch (error) {
      console.error('Error adding sparset to cart:', error);
      alert(error.message || 'Products could not be added to the cart.');
    } finally {
      button.removeAttribute('aria-busy');
      button.disabled = selectedVariantIds.length < minProducts;
    }
  }

  let resizeTimeout;
  const onResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      adjustGoalNodePositions();
      updateUI();
    }, 150);
  };

  window.addEventListener('resize', onResize);

  const productGrid = root.querySelector('.bk-media-sparset-builder__grid');
  if (productGrid && typeof ResizeObserver !== 'undefined') {
    const uspResizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(equalizeCardUspHeights);
    });
    uspResizeObserver.observe(productGrid);
  }

  const fallbackPreviewPercent = getPreviewDiscountFallbackPercent();
  resolvedPreviewDiscount = {
    type: fallbackPreviewPercent > 0 ? 'percentage' : null,
    value: fallbackPreviewPercent,
    code: null,
    loaded: true
  };

  initReferralCode();

  requestAnimationFrame(() => {
    adjustGoalNodePositions();
    updateUI();
  });

  if ((config.previewDiscountCode || '').trim()) {
    resolvePreviewDiscountCode().then(() => updateUI());
  }

  root._bkMediaSparsetInitialized = true;
}

function initAllBkMediaSparsetBuilders() {
  document.querySelectorAll('bk-media-sparset-builder').forEach(initBkMediaSparsetBuilder);
}

document.addEventListener('DOMContentLoaded', initAllBkMediaSparsetBuilders);
document.addEventListener('shopify:section:load', function (event) {
  setTimeout(function () {
    const builders = event.target ? event.target.querySelectorAll('bk-media-sparset-builder') : [];
    if (builders.length) {
      builders.forEach(function (root) {
        root._bkMediaSparsetInitialized = false;
        initBkMediaSparsetBuilder(root);
      });
      return;
    }
    initAllBkMediaSparsetBuilders();
  }, 100);
});

/* bk-media-sparset-builder end */

/* bk-media-bundle-cart-components start */

function initBkMediaBundleCartComponents() {
  document.querySelectorAll('.bk-media-line-item-components-disclosure').forEach((disclosure) => {
    disclosure.open = true;
    disclosure.setAttribute('aria-expanded', 'true');
  });
}

class BkMediaBundleComponentsScroll extends HTMLElement {
  connectedCallback() {
    if (this._initialized) {
      return;
    }

    this._initialized = true;
    this._abortController = new AbortController();
    this._scrollNearingThreshold = 125;
    this._allowTriggerNearingStartEvent = false;
    this._allowTriggerLeavingStartEvent = true;
    this._allowTriggerNearingEndEvent = true;
    this._allowTriggerLeavingEndEvent = false;

    this._checkIfScrollable = this._checkIfScrollable.bind(this);
    this._onScroll = this._onScroll.bind(this);
    this._prev = this._prev.bind(this);
    this._next = this._next.bind(this);

    new ResizeObserver(this._checkIfScrollable).observe(this);
    this.addEventListener('scroll', this._onScroll, { signal: this._abortController.signal });
    this.addEventListener('control:prev', this._prev, { signal: this._abortController.signal });
    this.addEventListener('control:next', this._next, { signal: this._abortController.signal });
    this._checkIfScrollable();
  }

  disconnectedCallback() {
    this._abortController?.abort();
    this._initialized = false;
  }

  get _scrollDirection() {
    if (this.scrollWidth > this.clientWidth) {
      return 'inline';
    }

    return 'none';
  }

  _getScrollStep() {
    const firstCard = this.querySelector('.bk-media-line-item-components__card');
    if (!firstCard) {
      return this.clientWidth * 0.8;
    }

    const cardStyles = getComputedStyle(firstCard);
    const listStyles = getComputedStyle(firstCard.parentElement);
    const gap = parseFloat(listStyles.columnGap || listStyles.gap || '0') || 0;
    const marginInline = (parseFloat(cardStyles.marginLeft) || 0) + (parseFloat(cardStyles.marginRight) || 0);

    return firstCard.offsetWidth + gap + marginInline;
  }

  _prev() {
    const direction = document.dir === 'rtl' ? 1 : -1;
    this.scrollBy({ left: direction * this._getScrollStep(), behavior: 'smooth' });
  }

  _next() {
    const direction = document.dir === 'rtl' ? -1 : 1;
    this.scrollBy({ left: direction * this._getScrollStep(), behavior: 'smooth' });
  }

  _checkIfScrollable() {
    this.classList.toggle('is-scrollable', this._scrollDirection !== 'none');
    this._onScroll();
  }

  _onScroll() {
    clearTimeout(this._scrollTimeout);

    if (this._scrollDirection === 'none') {
      return;
    }

    this._lastScrollPosition = this._lastScrollPosition ?? Math.abs(this.scrollLeft);

    const direction = this._lastScrollPosition > Math.abs(this.scrollLeft) ? 'start' : 'end';
    this._lastScrollPosition = Math.abs(this.scrollLeft);

    const scrollPosition = Math.round(Math.abs(this.scrollLeft));
    const scrollMinusSize = Math.round(this.scrollWidth - this.clientWidth);

    if (direction === 'start' && this._allowTriggerNearingStartEvent && scrollPosition <= this._scrollNearingThreshold) {
      this._allowTriggerNearingStartEvent = false;
      this._allowTriggerLeavingStartEvent = true;
      this.dispatchEvent(new CustomEvent('scroll:edge-nearing', { bubbles: true, detail: { position: 'start' } }));
    } else if (direction === 'end' && scrollPosition > this._scrollNearingThreshold) {
      this._allowTriggerNearingStartEvent = true;

      if (this._allowTriggerLeavingStartEvent) {
        this._allowTriggerLeavingStartEvent = false;
        this.dispatchEvent(new CustomEvent('scroll:edge-leaving', { bubbles: true, detail: { position: 'start' } }));
      }
    }

    if (direction === 'end' && this._allowTriggerNearingEndEvent && scrollMinusSize <= scrollPosition + this._scrollNearingThreshold) {
      this._allowTriggerNearingEndEvent = false;
      this._allowTriggerLeavingEndEvent = true;
      this.dispatchEvent(new CustomEvent('scroll:edge-nearing', { bubbles: true, detail: { position: 'end' } }));
    } else if (direction === 'start' && scrollMinusSize > scrollPosition + this._scrollNearingThreshold) {
      this._allowTriggerNearingEndEvent = true;

      if (this._allowTriggerLeavingEndEvent) {
        this._allowTriggerLeavingEndEvent = false;
        this.dispatchEvent(new CustomEvent('scroll:edge-leaving', { bubbles: true, detail: { position: 'end' } }));
      }
    }

    if (window.onscrollend === undefined) {
      this._scrollTimeout = setTimeout(() => {
        this.dispatchEvent(new CustomEvent('scrollend', { bubbles: true, composed: true }));
      }, 75);
    }
  }
}

if (!window.customElements.get('bk-media-bundle-components-scroll')) {
  window.customElements.define('bk-media-bundle-components-scroll', BkMediaBundleComponentsScroll);
}

document.addEventListener('DOMContentLoaded', initBkMediaBundleCartComponents);
document.addEventListener('cart:change', () => {
  requestAnimationFrame(initBkMediaBundleCartComponents);
});
document.addEventListener('shopify:section:load', () => {
  setTimeout(initBkMediaBundleCartComponents, 100);
});

/* bk-media-bundle-cart-components end */

/* bk-media-rebuy-bundle-compare start */

function getCartItemProperties(item) {
  const props = {};

  if (!item || !item.properties) {
    return props;
  }

  if (Array.isArray(item.properties)) {
    item.properties.forEach((entry) => {
      const key = entry.name || entry.first || entry.key;
      const value = entry.value || entry.last;
      if (key) {
        props[key] = value;
      }
    });
    return props;
  }

  if (typeof item.properties === 'object') {
    return { ...item.properties };
  }

  return props;
}

function parseBundlePricing(props) {
  const raw = props._BundlePricing || props['Bundle pricing'];
  if (!raw || typeof raw !== 'string') {
    return null;
  }

  const parts = raw.split('|').map((value) => parseInt(value, 10));
  if (parts.length < 4 || parts.some((value) => Number.isNaN(value))) {
    return null;
  }

  return {
    compareTotal: parts[0],
    saleTotal: parts[1],
    discountPercent: parts[2],
    compareAtTotal: parts[3]
  };
}

function getBundleSaleCents(item, cartItems) {
  const props = getCartItemProperties(item);
  const bundlePricing = parseBundlePricing(props);
  const bundleId = props._BundleId;
  const bundleRole = props._BundleRole || props['Bundle role'];

  if (bundleRole === 'child') {
    return item.final_line_price || item.line_price || 0;
  }

  if (bundlePricing?.saleTotal > 0) {
    return bundlePricing.saleTotal;
  }

  let saleCents = item.final_line_price || item.line_price || 0;

  if (!bundleId || !Array.isArray(cartItems)) {
    return saleCents;
  }

  saleCents = cartItems.reduce((sum, line) => {
    const lineProps = getCartItemProperties(line);
    if (lineProps._BundleId !== bundleId) {
      return sum;
    }

    return sum + (line.final_line_price || line.line_price || 0);
  }, 0);

  const discountPercent = parseInt(props._BundleDiscountPercent, 10) || bundlePricing?.discountPercent || 0;
  const discountedTotal = parseInt(props._BundleDiscountedTotal, 10) || bundlePricing?.saleTotal || 0;

  if (discountPercent > 0 && discountedTotal > 0) {
    saleCents = discountedTotal;
  }

  return saleCents;
}

function getBundleCompareCents(item, cartItems) {
  const props = getCartItemProperties(item);
  const bundlePricing = parseBundlePricing(props);
  const saleCents = getBundleSaleCents(item, cartItems);
  const compareFromProps = parseInt(props._BundleCompareTotal, 10) || bundlePricing?.compareTotal || 0;

  if (compareFromProps > saleCents) {
    return compareFromProps;
  }

  const compareAtFromProps = parseInt(props._BundleCompareAtTotal, 10) || bundlePricing?.compareAtTotal || 0;
  if ((props._BundleShowVariantCompareAt === 'true' || compareAtFromProps > compareFromProps) && compareAtFromProps > saleCents) {
    return compareAtFromProps;
  }

  const finalCents = item.final_line_price || item.line_price || 0;

  if (item.original_line_price > saleCents) {
    return item.original_line_price;
  }

  if (item.variant?.compare_at_price > item.variant?.price) {
    const variantCompare = (item.variant.compare_at_price || 0) * (item.quantity || 1);
    if (variantCompare > saleCents) {
      return variantCompare;
    }
  }

  if (compareFromProps > finalCents) {
    return compareFromProps;
  }

  return 0;
}

function formatCartMoney(cents) {
  if (window.Shopify?.formatMoney) {
    return window.Shopify.formatMoney(cents, window.themeVariables?.settings?.moneyFormat);
  }

  return `${(cents / 100).toFixed(2)}`;
}

function injectRebuyBundleComparePrices(cart) {
  if (!window.Rebuy || !cart?.items?.length) {
    return;
  }

  const flyout = document.querySelector('.rebuy-cart__flyout');
  if (!flyout) {
    return;
  }

  cart.items.forEach((item, index) => {
    const props = getCartItemProperties(item);
    if ((props._BundleRole || props['Bundle role']) === 'child') {
      return;
    }

    const compareCents = getBundleCompareCents(item, cart.items);
    if (!compareCents) {
      return;
    }

    const saleCents = getBundleSaleCents(item, cart.items);
    const row = flyout.querySelector(`[data-rebuy-cart-item-index="${index}"]`) || flyout.querySelector(`[data-line-item-key="${item.key}"]`);
    const priceEl = row?.querySelector('.rebuy-cart__flyout-item-price, .rebuy-money');

    if (!priceEl || priceEl.dataset.bkBundleCompareApplied === 'true') {
      return;
    }

    priceEl.dataset.bkBundleCompareApplied = 'true';
    priceEl.innerHTML = `<span class="rebuy-money sale-price">${formatCartMoney(saleCents)}</span><span class="rebuy-money compare-at-price text-subdued line-through">${formatCartMoney(compareCents)}</span>`;
  });
}

async function refreshRebuyBundleComparePrices() {
  if (!window.Rebuy) {
    return;
  }

  try {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`);
    if (!response.ok) {
      return;
    }

    const cart = await response.json();
    requestAnimationFrame(() => injectRebuyBundleComparePrices(cart));
  } catch (error) {
    console.error('Failed to refresh Rebuy bundle compare prices:', error);
  }
}

document.addEventListener('DOMContentLoaded', refreshRebuyBundleComparePrices);
document.addEventListener('cart:change', refreshRebuyBundleComparePrices);
document.addEventListener('rebuy:cart.change', refreshRebuyBundleComparePrices);
document.addEventListener('rebuy:smartcart.show', refreshRebuyBundleComparePrices);

/* bk-media-rebuy-bundle-compare end */

/* bk-media judgeme floating widget start */

function initJudgemeFloatingWidget() {
  var root = document.querySelector('[data-bk-media-jdgm-float]');
  if (!root) return;

  var dismissBtn = root.querySelector('[data-bk-media-jdgm-float-dismiss]');

  try {
    localStorage.removeItem('bk-media:jdgm-float-dismissed');
  } catch (e) {}

  root.hidden = false;

  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      root.classList.add('is-visible');
    });
  });

  function dismiss() {
    if (root.classList.contains('is-dismissing')) return;

    root.classList.remove('is-visible');
    root.classList.add('is-dismissing');

    var done = false;
    function cleanup() {
      if (done) return;
      done = true;
      root.remove();
    }

    root.addEventListener('transitionend', cleanup, { once: true });
    setTimeout(cleanup, 400);
  }

  if (dismissBtn) {
    dismissBtn.addEventListener('click', dismiss);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initJudgemeFloatingWidget);
} else {
  initJudgemeFloatingWidget();
}

/* bk-media judgeme floating widget end */
